import first from "../Assets/USA/first.png";
import second from "../Assets/USA/second.png";
import iot1 from "../Assets/USA/iot1.png";
import iot2 from '../Assets/USA/Data-analytics-courses-in-USA.jpg'
import iot3 from '../Assets/USA/MBA-in-healthcare-management-in-USA.jpg'
import iot4 from '../Assets/USA/Best-online-MBA-in-USA.jpg'
import faq1 from "../Assets/USA/faq1.png";
import usafaq1 from "../Assets/USA/faq1.png";
import usafaq2 from '../Assets/USA/Finding-the-Right-Job-Portals-and-Opportunities.jpg'
import usafaq3 from '../Assets/USA/Balancing-Study-and-Work-in-the-USA.jpg'
import usafaq4 from '../Assets/USA/Post-Graduation-Career-Planning.jpg'
import usafaq5 from '../Assets/USA/Living-and-Thriving-in-America.jpg'
import usafaq6 from '../Assets/USA/USA-Journey.jpg';
import ukcourse1 from '../Assets/UK/Business-and-management-studies.jpg'
import ukcourse2 from '../Assets/UK/Data-science-and-analytics.jpg'
import ukcourse3 from '../Assets/UK/Engineering-and-technology.jpg'
import ukcourse4 from '../Assets/UK/Healthcare-and-life-sciences.jpg'
import ukfirst from "../Assets/UK/Low-Cost-Universities-in-UK-for-International-Students.jpg"
import uksecond from "../Assets/UK/Affordable-Education-in-the-UK.jpg"
import ukfaq1 from '../Assets/UK/Career-Opportunities-in-the-UK.jpg'
import ukfaq2 from '../Assets/UK/Finding-the-Right-Job-Portals-and-Opportunities-uk.jpg'
import ukfaq3 from '../Assets/UK/Medium-Term-Career-Planning-for-International-Students.jpg'
import ukfaq4 from '../Assets/UK/Life-in-the-UK-as-an-International-Student.jpg'
import ukfaq5 from '../Assets/UK/Remote-and-Flexible-Work-Opportunities.jpg'
import ukfaq6 from '../Assets/UK/Balancing-Work-and-Study.jpg'
import ukfaq7 from '../Assets/UK/Best-UK-Education-Partner.jpg'
import australiafirst from '../Assets/AUSTRALIA/Careers-in-Australia– Your-Complete-Guide-to-Studying,-Working,-and-Living-in-Australia.jpg'
import australiasecond from '../Assets/AUSTRALIA/Degree-in-Australia–Your-Gateway-to-Global-Careers.jpg'
import austcourse1 from '../Assets/AUSTRALIA/Business-and-management.jpg'
import austcourse2 from '../Assets/AUSTRALIA/Information-technology.jpg'
import austcourse3 from '../Assets/AUSTRALIA/Engineering-and-construction.jpg'
import austcourse4 from '../Assets/AUSTRALIA/Healthcare-and-nursing.jpg'
import austcourse5 from '../Assets/AUSTRALIA/Environmental-sciences.jpg'
import austcourse6 from '../Assets/AUSTRALIA/Creative-arts.jpg'
import austfaq1 from '../Assets/AUSTRALIA/Work-in-Australia-as-an-International-Student.jpg'
import austfaq2 from '../Assets/AUSTRALIA/Finding the-Right-Job-in-Australia.jpg'
import austfaq3 from '../Assets/AUSTRALIA/Australia-Job-Vacancy-Updates.jpg'
import austfaq4 from '../Assets/AUSTRALIA/Life-in-Australia-as-an-International-Student-or-Worker.jpg'
import austfaq5 from '../Assets/AUSTRALIA/Best-Partner-for-Studying-and-Working-in-Australia.jpg'
import austfaq6 from '../Assets/AUSTRALIA/Australia-Job-Vacancy-Updates.jpg'
import austfaq7 from '../Assets/AUSTRALIA/Life-in-Australia-as-an-International-Student-or-Worker.jpg'
import austfaq8 from '../Assets/AUSTRALIA/Best-Partner-for-Studying-and-Working-in-Australia.jpg'
import canadafirst from '../Assets/canada/Nova-Edubridge-Your-Pathway-to-Careers,-Jobs,-and-Education-in-Canada.jpg'
import canadasecond from '../Assets/canada/You-rNext-Step-Towards-Canada.jpg'
import canadacourse1 from '../Assets/canada/Globally-Ranked-Education-System.jpg'
import canadacourse2 from '../Assets/canada/High-Employment-Rate.jpg'
import canadacourse3 from '../Assets/canada/Pathways-to-Permanent-Residency.jpg'
import canadacourse4 from '../Assets/canada/Quality-of-Life.jpg'
import canadafaq1 from '../Assets/canada/Study-in-Canada-Build-a-Strong-Future.jpg'
import canadafaq2 from '../Assets/canada/Work-in-Canada–Career-Opportunities-Await.jpg'
import canadafaq3 from '../Assets/canada/Jobs-in-Canada-for-Foreigners-How-We-Help.jpg'
import canadafaq4 from '../Assets/canada/Canada-Work-Visa-Your-Gateway-to-Employment.jpg'
import canadafaq5 from '../Assets/canada/Canada-Job-Vacancy-Find-the-Right-Fit.jpg'
import canadafaq6 from '../Assets/canada/Careers-in-Canada-Build-a-Life-You-Love.jpg'
import canadafaq7 from '../Assets/canada/Why-Choose-Nova-Edubridge-for-Your-Canada-Journey.jpg'
import newfirst from '../Assets/newzealand/Unlock-Your-Future-with-World-Class-Education-in-New-Zealand.jpg'
import newsecond from '../Assets/newzealand/Start-Your-New-Zealand-Dream-Today.jpg'
import newcourse1 from '../Assets/newzealand/World-Class-Education.jpg'
import newcourse2 from '../Assets/newzealand/Work-While-You-Study.jpg'
import newcourse3 from '../Assets/newzealand/Employment-New-Zealand-Legal-Requirements-and-Work-Rights.jpg'
import newcourse4 from '../Assets/newzealand/Immigration-Pathways.jpg'
import newfaq1 from '../Assets/newzealand/Study-in-New-Zealand-Academic-Excellence-Meets-Practical-Experience.jpg'
import newfaq2 from '../Assets/newzealand/Careers-in-New-Zealand-Opportunities-for-Growth.jpg'
import newfaq3 from '../Assets/newzealand/Jobs-in-New-Zealand-for-Foreigners-Your-Pathway-to-Employment.jpg'
import newfaq4 from '../Assets/newzealand/Work-in-New-Zealand-for-Foreigners-Balancing-Lifestyle-and-Career.jpg'
import newfaq5 from '../Assets/newzealand/New-Zealand-Hiring-Trends-In-Demand-Skills.jpg'
import newfaq6 from '../Assets/newzealand/Employment-New-Zealand-Legal-Requirements-and-Work-Rights.jpg'
import newfaq7 from '../Assets/newzealand/Visa-Pathways-Study-and-Work.jpg'
import newfaq8 from '../Assets/newzealand/Why-Choose-Nova- Edubridge-fo-Your-New-Zealand-Journey.jpg'
import irelandfirst from '../Assets/ireland/Experience-World-Class-Education-Culture-in-Ireland.jpg'
import irelandsecond from '../Assets/ireland/Jobs-Northern-Ireland-Additional-Opportunities.jpg'
import irelandcourse1 from '../Assets/ireland/Top-Tier-Education.jpg'
import irelandcourse2 from '../Assets/ireland/Post-Study-Work-Opportunities-ireland.jpg'
import irelandcourse3 from '../Assets/ireland/Booming-Job-Market.jpg'
import irelandcourse4 from '../Assets/ireland/Gateway-to-Europe.jpg'
import irelandfaq1 from '../Assets/ireland/Study-in-Ireland-Quality-Education-for-Global-Careers.jpg'
import irelandfaq2 from '../Assets/ireland/Ireland-Universities-for-International-Students-Your-Options.jpg'
import irelandfaq3 from '../Assets/ireland/Jobs-in-Ireland-Building-Your-Career.jpg'
import irelandfaq4 from '../Assets/ireland/Work-Rights-for-International-Students.jpg'
import irelandfaq5 from '../Assets/ireland/Visa-and-Immigration-Support.jpg'
import irelandfaq6 from '../Assets/ireland/Work-Rights-for-International-Students.jpg'
import irelandfaq7 from '../Assets/ireland/Visa-and-Immigration-Support.jpg'
import irelandfaq8 from '../Assets/ireland/Why-Choose-Nova-Edubridge-for-Ireland.jpg'
import irelandfaq9 from '../Assets/ireland/Take-the-First-Step-Towards-Ireland.jpg'
import germanyfirst from '../Assets/germany/Discover-Quality-Learning-Bright-Futures-in-Germany.jpg'
import germanysecond from '../Assets/germany/Start-Your-Germany-Journey-Today.jpg'
import germanycourse1 from '../Assets/germany/World-Class-Education-germany.jpg'
import germanycourse2 from '../Assets/germany/Affordable-Tuition.jpg'
import germanycourse3 from '../Assets/germany/Post-Study-Work-Opportunities-germany.jpg'
import germanycourse4 from '../Assets/germany/Thriving-Job-Market.jpg'
import germanyfaq1 from '../Assets/germany/Study-in-Germany-Academic-Excellence-for-Global-Success.jpg'
import germanyfaq2 from '../Assets/germany/Universities-in-Germany-for-International-Students.jpg'
import germanyfaq3 from '../Assets/germany/Masters-in-Germany-A-Gateway-to-High-Paying-Careers.jpg'
import germanyfaq4 from '../Assets/germany/Jobs-in-Germany-For-Locals-and-Foreigners.jpg'
import germanyfaq5 from '../Assets/germany/Work-in-Germany-Lifestyle-and-Professional-Growth.jpg'
import germanyfaq6 from '../Assets/germany/Jobs-in-Germany-for-Indians-High-Demand-Roles.jpg'
import germanyfaq7 from '../Assets/germany/Visa-and-Work-Permit-Guidance.jpg'
import germanyfaq8 from '../Assets/germany/Why-Choose-Nova-Edubridge-for-Your-Germany-Journey.jpg'
import francefirst from '../Assets/France/Nova-Edubridge-Your-Gateway-to-Study-and-Work-in-France.jpg'
import francesecond from '../Assets/France/Start-Your-France-Journey-Today.jpg'
import francecourse1 from '../Assets/France/World-class-universities-offering-globally-recognized-degrees.jpg'
import francecourse2 from '../Assets/France/Strong-industries-including-technology.jpg'
import francecourse3 from '../Assets/France/Excellent-work-life-balance.jpg'
import francecourse4 from '../Assets/France/Access-to-European-markets.jpg'
import francecourse5 from '../Assets/France/Rich-cultural-experiences.jpg'
import francefaq1 from '../Assets/France/Study-in-France-World-Class-Education.jpg'
import francefaq2 from '../Assets/France/Jobs-in-France-Opportunities-for-All.jpg'
import francefaq3 from '../Assets/France/Careers-in-France-Build-Your-Future.jpg'
import francefaq4 from '../Assets/France/France-Work-Visa-You-Pathway-to-Employment.jpg'
import francefaq5 from '../Assets/France/Jobs-in-France-for-Foreigners-Global-Talent-Welcome.jpg'
import francefaq6 from '../Assets/France/France-Job-Vacancy-Updates-Stay-Ahead.jpg'
import francefaq7 from '../Assets/France/Why-Choose-Nova-Edubridge-for-France.jpg'
import francefaq8 from '../Assets/France/Study-in-France-Your-Pathway-to-World-Class-Education-and-Career-Opportunities.jpg'
import francefaq9 from '../Assets/France/Why-Study-in-France-for-International-Students.jpg'
import francefaq10 from '../Assets/France/Top-Universities-in-France.jpg'
import francefaq11 from '../Assets/France/Career-Opportunities-and-Jobs-in-France.jpg'
import francefaq12 from '../Assets/France/Work-Life-and-Cultural-Benefits.jpg'
import europefirst from '../Assets/europe/Study-in-Europe-Your-Pathway-to-World-Class-Education-and-Global-Careers.jpg'
import europesecond from '../Assets/europe/Why-Choose-Europe-for-Your-Studies.jpg'
import europecourse1 from '../Assets/europe/Choose-Your-Country-and-Program.jpg'
import europecourse2 from '../Assets/europe/Check-Entry-Requirements.jpg'
import europecourse3 from '../Assets/europe/Apply-to-Universities-in-Europe-for-International-Students.jpg'
import europecourse4 from '../Assets/europe/Secure-Scholarships-and-Funding.jpg'
import europecourse5 from '../Assets/europe/Prepare-for-Life-Abroad.jpg'
import europefaq1 from '../Assets/europe/Work-Opportunities-Build-Your-Career-While-Studying.jpg'
import europefaq2 from '../Assets/europe/Affordable-Education-and-Scholarships.jpg'
import europefaq3 from '../Assets/europe/Living-and-Experiencing-Europe.jpg'
import europefaq4 from '../Assets/europe/Cultural-Advantages.jpg'
import europefaq5 from '../Assets/europe/High-Demand-Job-Sectors.jpg'
import europefaq6 from '../Assets/europe/Visa-and-Immigration-Benefits.jpg'
import europefaq7 from '../Assets/europe/Europe-Where-Education-Meets-Opportunity.jpg'
import europefaq8 from '../Assets/europe/Study-in-Europe-Endless-Education-and-Work-Opportunities-Across-the-Continent.jpg'
import europefaq9 from '../Assets/europe/Why-Study-in-Europe-for-International-Students.jpg'
import europefaq10 from '../Assets/europe/Top-Universities-in-Europe.jpg'
import europefaq11 from '../Assets/europe/Work-Anywhere-in-Europe.jpg'
import europefaq12 from '../Assets/europe/Work-Abroad-and-Remote-Opportunities.jpg'
import asiafirst from '../Assets/Asia/Study- Work,-and-Build-Your-Future-in-Asia-with-Nova-Edubridge.jpg'
import asiasecond from '../Assets/Asia/Why-Choose-Asia-for-Your-Studies-and-Career.jpg'
import asiacourse1 from '../Assets/Asia/Personalized-Counselling.jpg'
import asiacourse2 from '../Assets/Asia/University-and-Job-Matching.jpg'
import asiacourse3 from '../Assets/Asia/Visa-and-Documentation-Support.jpg'
import asiacourse4 from '../Assets/Asia/Pre-departure-Training.jpg'
import asiacourse5 from '../Assets/Asia/Ongoing-Career-Support.jpg'
import asiafaq1 from '../Assets/Asia/Study-in-Asia-Academic-Excellence-Meets-Cultural-Diversity.jpg'
import asiafaq2 from '../Assets/Asia/Jobs-in-Asia-for-Foreigners-Your-Global-Career-Starts-Here.jpg'
import asiafaq3 from '../Assets/Asia/Careers-in-Asia-Long-Term-Growth-and-Stability.jpg'
import asiafaq4 from '../Assets/Asia/Asia-Work-Visa-Assistance.jpg'
import asiafaq5 from '../Assets/Asia/Jobs-in-Asia-Opportunities-Across-Industries.jpg'
import asiafaq6 from '../Assets/Asia/Start-Your-Asian-ream-with-Nova-Edubridge.jpg'
import Dubaifaq1 from '../Assets/DUBAI/Academic-Excellence-in-Dubai.jpg'
import Dubaifaq2 from '../Assets/DUBAI/Career-Opportunities-in-Dubai.jpg'
import Dubaifaq3 from '../Assets/DUBAI/Long-Term-Careers-in-Dubai.jpg'
import Dubaifaq4 from '../Assets/DUBAI/Visa-Guidance-for-Dubai.jpg'
import Dubaicourse1 from '../Assets/DUBAI/World-Class-Education-dubai.jpg'
import Dubaicourse2 from '../Assets/DUBAI/Dynamic-Job-Market-dubai.jpg'
import Dubaicourse3 from '../Assets/DUBAI/Safe-Multicultural-Environment-dubai.jpg'
import Dubaicourse4 from '../Assets/DUBAI/Tax-Free-Salaries-Career-Growth-dubai.jpg'
import Dubaifirst from '../Assets/DUBAI/Shape-Your-Academic-and-Professional-Journey-in-Dubai-with-Nova-Edubridge.jpg'
import DubaiSecond from '../Assets/DUBAI/Why-Choose-Dubai.jpg'
import Singaporefaq1 from '../Assets/SINGAPORE/Academic-Excellence-in-Singapore.jpg'
import Singaporefaq2 from '../Assets/SINGAPORE/Jobs-in-Singapore.jpg'
import Singaporefaq3 from '../Assets/SINGAPORE/Long-Term-Careers-in-Singapore.jpg'
import Singaporefaq4 from '../Assets/SINGAPORE/Visa-Assistance-Singapore.jpg'
import Singaporecourse1 from '../Assets/SINGAPORE/Top-Universities-in-Singapore.jpg'
import Singaporecourse2 from '../Assets/SINGAPORE/Economic-Powerhouse-singapore.jpg'
import Singaporecourse3 from '../Assets/SINGAPORE/Safe-Multicultural-Society-in-Singapore.jpg'
import Singaporecourse4 from '../Assets/SINGAPORE/Career-Development-singapore.jpg'
import Singaporefirst from '../Assets/SINGAPORE/Build-Your-Academic-and-Professional-Future-in-Singapore-with-Nova-Edubridge.jpg'
import SingaporeSecond from '../Assets/SINGAPORE/Why-Choose-Singapore.jpg'
import Switzerlandfaq1 from '../Assets/SWITZERLAND/Academic-Excellence-in-Switzerland.jpg'
import Switzerlandfaq2 from '../Assets/SWITZERLAND/Jobs-in-Switzerland.jpg'
import Switzerlandfaq3 from '../Assets/SWITZERLAND/Long-Term-Careers-in-Switzerland.jpg'
import Switzerlandfaq4 from '../Assets/SWITZERLAND/Visa-Guidance-in-Switzerland.jpg'
import Switzerlandcourse1 from '../Assets/SWITZERLAND/Academic-Excellenc-eSwitzerland.jpg'
import Switzerlandcourse2 from '../Assets/SWITZERLAND/Thriving-Industries-switzerland.jpg'
import Switzerlandcourse3 from '../Assets/SWITZERLAND/High-Quality-of-Life-Switzerland.jpg'
import Switzerlandcourse4 from '../Assets/SWITZERLAND/Global-Career-Prospects-switzerland.jpg'
import Switzerlandfirst from '../Assets/SWITZERLAND/Achieve-Academic-and-Professional-Excellence-in-Switzerland-with-Nova-Edubridge.jpg'
import SwitzerlandSecond from '../Assets/SWITZERLAND/Why-Choose-Switzerland.jpg'
import NetherlandsFaq1 from '../Assets/Netherlands/Academic-Excellence-in-the-Netherlands.jpg'
import NetherlandsFaq2 from '../Assets/Netherlands/Jobs-in-the-Netherlands.jpg'
import NetherlandsFaq3 from '../Assets/Netherlands/Long-Term-Careers-in-the-Netherlands.jpg'
import NetherlandsFaq4 from '../Assets/Netherlands/Visa-Guidance-in-the-Netherlands.jpg'
import NetherlandsCourse1 from '../Assets/Netherlands/Innovative-Learning-Environment-Netherlands.jpg'
import NetherlandsCourse2 from '../Assets/Netherlands/Hub-for-Technology-and-Design-in-Netherlands.jpg'
import NetherlandsCourse3 from '../Assets/Netherlands/Gateway-to-European-Careers-in-netherlands.jpg'
import NetherlandsCourse4 from '../Assets/Netherlands/Student-Friendly-Lifestyle.jpg'
import NetherlandsFirst from '../Assets/Netherlands/Achieve-Academic-and-Professional-Excellence-in-the-Netherlands-with-Nova-EduBridge.jpg'
import NetherlandsSecond from '../Assets/Netherlands/Why-Choose-the-Netherlands.jpg'
import ItalyFaq1 from '../Assets/ITALY/Academic-Growth-in-Italy.jpg'
import ItalyFaq2 from '../Assets/ITALY/Career-Opportunities-in-italy.jpg'
import ItalyFaq3 from '../Assets/ITALY/Long-Term-Prospects-in-Italy.jpg'
import ItalyFaq4 from '../Assets/ITALY/Visa-Support-in-Italy.jpg'
import ItalyCourse1 from '../Assets/ITALY/Historic-Learning-Hubs-in-Italy.jpg'
import ItalyCourse2 from '../Assets/ITALY/Design-and-Creative-Capital.jpg'
import ItalyCourse3 from '../Assets/ITALY/Diverse-Job-Market-in-Italy.jpg'
import ItalyCourse4 from '../Assets/ITALY/Lifestyle-and-Connectivity-in-Italy.jpg'
import ItalyFirst from '../Assets/ITALY/Shape-Your-Academic-and-Professional-Journey-in-Italy.jpg'
import ItalySecond from '../Assets/ITALY/Why-Choose-Italy.jpg'
import PolandFaq1 from '../Assets/POLAND/Academic-Excellence-in-Poland.jpg'
import PolandFaq2 from '../Assets/POLAND/Jobs-in-Poland.jpg'
import PolandFaq3 from '../Assets/POLAND/Long-Term-Careers-in-Poland.jpg'
import PolandFaq4 from '../Assets/POLAND/Visa-and-Immigration-Support-in-Poland.jpg'
import PolandCourse1 from '../Assets/POLAND/Modern-Education-System-in-Poland.jpg'
import PolandCourse2 from '../Assets/POLAND/Growing-Job-Market-in-poland.jpg'
import PolandCourse3 from '../Assets/POLAND/Affordable-and-Accessible-in-Poland.jpg'
import PolandCourse4 from '../Assets/POLAND/Cultural-and-European-Access.jpg'
import PolandFirst from '../Assets/POLAND/Advance-Your-Academic-and-Career-Goals-in-Poland-with-Nova-EduBridge.jpg'
import PolandSecond from '../Assets/POLAND/Why-Choose-Poland.jpg'
import GeorgiaFaq1 from '../Assets/GEORGIA/Academic-Excellence-in-Georgia.jpg'
import GeorgiaFaq2 from '../Assets/GEORGIA/Jobs-in-Georgia.jpg'
import GeorgiaFaq3 from '../Assets/GEORGIA/Long-Term-Careers-in-Georgia.jpg'
import GeorgiaFaq4 from '../Assets/GEORGIA/Visa-and-Documentation-Support-in-Georgia.jpg'
import GeorgiaCourse1 from '../Assets/GEORGIA/Affordable-World-Class-Learning.jpg'
import GeorgiaCourse2 from '../Assets/GEORGIA/Medical-and-Technical-Excellence.jpg'
import GeorgiaCourse3 from '../Assets/GEORGIA/Growing-Job-Sectors-in-Georgia.jpg'
import GeorgiaCourse4 from '../Assets/GEORGIA/Safe and-Welcoming-Environment.jpg'
import GeorgiaFirst from '../Assets/GEORGIA/Achieve-Your-Academic-and-Professional-Goals-in-Georgia.jpg'
import GeorgiaSecond from '../Assets/GEORGIA/Why-Choose-Georgia.jpg'
import RussiaFaq1 from '../Assets/RUSSIA/Academic-Strength-in-Russia.jpg'
import RussiaFaq2 from '../Assets/RUSSIA/Jobs-in-Russia.jpg'
import RussiaFaq3 from '../Assets/RUSSIA/Long-Term-Careers-in-Russia.jpg'
import RussiaFaq4 from '../Assets/RUSSIA/Visa-and-Immigration-Support-in-russia.jpg'
import RussiaCourse1 from '../Assets/RUSSIA/Globally-Recognized-Education.jpg'
import RussiaCourse2 from '../Assets/RUSSIA/Affordable-Tuition-and-Living-in-russia.jpg'
import RussiaCourse3 from '../Assets/RUSSIA/Strong-Industry-Links-in-russia.jpg'
import RussiaCourse4 from '../Assets/RUSSIA/Cultural-and-Lifestyle-Benefits-in-russia.jpg'
import RussiaFirst from '../Assets/RUSSIA/Expand-Your-Academic-and-Career-Horizons-in-Russia-with-Nova-EduBridge.jpg'
import RussiaSecond from '../Assets/RUSSIA/Why-Choose-Russia.jpg'
import KyrgyzstanFaq1 from '../Assets/KYRGYZSTAN/Academic-Opportunities-in-Kyrgyzstan.jpg'
import KyrgyzstanFaq2 from '../Assets/KYRGYZSTAN/Jobs-in-Kyrgyzstan.jpg'
import KyrgyzstanFaq3 from '../Assets/KYRGYZSTAN/Future-Career-Prospects-in-Kyrgyzstan.jpg'
import KyrgyzstanFaq4 from '../Assets/KYRGYZSTAN/Visa-and-Support-Services-kyrgyzstan.jpg'
import KyrgyzstanCourse1 from '../Assets/KYRGYZSTAN/Affordable-Quality-Education.jpg'
import KyrgyzstanCourse2 from '../Assets/KYRGYZSTAN/English-Taught-Programs.jpg'
import KyrgyzstanCourse3 from '../Assets/KYRGYZSTAN/Emerging-Career-Sectors-in -Kyrgyzstan.jpg'
import KyrgyzstanCourse4 from '../Assets/KYRGYZSTAN/Safe-and-Student-Friendly-Environment.jpg'
import KyrgyzstanFirst from '../Assets/KYRGYZSTAN/Build-Your-Academic-and-Professional-Path-in-Kyrgyzstan.jpg'
import KyrgyzstanSecond from '../Assets/KYRGYZSTAN/Why-Choose-Kyrgyzstan.jpg'
import KazakhstanFaq1 from '../Assets/KAZAKHSTAN/Academic-Excellence-in-Kazakhstan.jpg'
import KazakhstanFaq2 from '../Assets/KAZAKHSTAN/Jobs-in-Kazakhstan.jpg'
import KazakhstanFaq3 from '../Assets/KAZAKHSTAN/Future-Prospects-kazakhstan.jpg'
import KazakhstanFaq4 from '../Assets/KAZAKHSTAN/Visa-and- Documentation-in-Kazakhstan.jpg'
import KazakhstanCourse1 from '../Assets/KAZAKHSTAN/Globally-Recognized-Universities-in-Kazakhstan.jpg'
import KazakhstanCourse2 from '../Assets/KAZAKHSTAN/Affordable-Learning-in-Kazakhstan.jpg'
import KazakhstanCourse3 from '../Assets/KAZAKHSTAN/English-Medium-Courses.jpg'
import KazakhstanCourse4 from '../Assets/KAZAKHSTAN/Growing-Career-Sectors.jpg'
import KazakhstanFirst from '../Assets/KAZAKHSTAN/Shape-Your-Academic-and-Career-Path-in-Kazakhstan.jpg'
import KazakhstanSecond from '../Assets/KAZAKHSTAN/Why-Choose-Kazakhstan.jpg'
import UzbekistanFaq1 from '../Assets/UZBEKISTHAN/Academic-Excellence-in-Uzbekistan.jpg'
import UzbekistanFaq2 from '../Assets/UZBEKISTHAN/Jobs-in-Uzbekistan.jpg'
import UzbekistanFaq3 from '../Assets/UZBEKISTHAN/Future-Opportunities-in-Uzbekistan.jpg'
import UzbekistanFaq4 from '../Assets/UZBEKISTHAN/Visa-Support-uzbekistan.jpg'
import UzbekistanCourse1 from '../Assets/UZBEKISTHAN/Recognized-Universities.jpg'
import UzbekistanCourse2 from '../Assets/UZBEKISTHAN/Budget-Friendly-Living-in-Uzbekistan.jpg'
import UzbekistanCourse3 from '../Assets/UZBEKISTHAN/English-Medium-Options.jpg'
import UzbekistanCourse4 from '../Assets/UZBEKISTHAN/Growing-Industries-in-Uzbekistan.jpg'
import UzbekistanFirst from '../Assets/UZBEKISTHAN/Achieve-Academic-Excellence-and-Career-Success-in-Uzbekistan.jpg'
import UzbekistanSecond from '../Assets/UZBEKISTHAN/Why-Choose-Uzbekistan.jpg'
import AfghanistanFaq1 from '../Assets/AFGHANISTAN/Academic-Growth-in-Afghanistan.jpg'
import AfghanistanFaq2 from '../Assets/AFGHANISTAN/Career-Options-in-Afghanistan.jpg'
import AfghanistanFaq3 from '../Assets/AFGHANISTAN/Future-Pathways-afghanistan.jpg'
import AfghanistanFaq4 from '../Assets/AFGHANISTAN/Visa-and-Support-afghanistan.jpg'
import AfghanistanCourse1 from '../Assets/AFGHANISTAN/Affordable-Education-Afghanistan.jpg'
import AfghanistanCourse2 from '../Assets/AFGHANISTAN/Emerging-Industries-in-Afghanistan.jpg'
import AfghanistanCourse3 from '../Assets/AFGHANISTAN/Cultural-Immersion.jpg'
import AfghanistanCourse4 from '../Assets/AFGHANISTAN/Community-Impact.jpg'
import AfghanistanFirst from '../Assets/AFGHANISTAN/Explore-Academic-and-Professional-Opportunities-in-Afghanistan.jpg'
import AfghanistanSecond from '../Assets/AFGHANISTAN/Why-Choose-Afghanistan.jpg'
import ChinaFirst from '../Assets/China/10.jpg'
import ChinaSecond from '../Assets/China/11.jpg'
import ChinaCourse1 from '../Assets/China/12.jpg'
import ChinaCourse2 from '../Assets/China/7.jpg'
import ChinaCourse3 from '../Assets/China/8.jpg'
import ChinaCourse4 from '../Assets/China/9.jpg'
import ChinaFaq1 from '../Assets/UZBEKISTHAN/Academic-Excellence-in-Uzbekistan.jpg'
import ChinaFaq2 from '../Assets/UZBEKISTHAN/Jobs-in-Uzbekistan.jpg'
import ChinaFaq3 from '../Assets/UZBEKISTHAN/Future-Opportunities-in-Uzbekistan.jpg'
import ChinaFaq4 from '../Assets/UZBEKISTHAN/Visa-Support-uzbekistan.jpg'
import SouthKoreaFirst from '../Assets/Korea/1.jpg'
import SouthKoreaSecond from '../Assets/Korea/2.jpg'
import KoreaCourse1 from '../Assets/Korea/3.jpg'
import KoreaCourse2 from '../Assets/Korea/4.jpg'
import KoreaCourse3 from '../Assets/Korea/5.jpg'
import KoreaCourse4 from '../Assets/Korea/6.jpg'
import KoreaFaq1 from '../Assets/SINGAPORE/Academic-Excellence-in-Singapore.jpg'
import KoreaFaq2 from '../Assets/SINGAPORE/Jobs-in-Singapore.jpg'
import KoreaFaq3 from '../Assets/SINGAPORE/Long-Term-Careers-in-Singapore.jpg'
import KoreaFaq4 from '../Assets/SINGAPORE/Visa-Assistance-Singapore.jpg'
import JapanFirst from '../Assets/japan/1.jpg'
import JapanSecond from '../Assets/japan/2.jpg'
import JapanCourse1 from '../Assets/japan/3.jpg'
import JapanCourse2 from '../Assets/japan/4.jpg'
import JapanCourse3 from '../Assets/japan/5.jpg'
import JapanCourse4 from '../Assets/japan/6.jpg'
import JapanFaq1 from '../Assets/ITALY/Academic-Growth-in-Italy.jpg'
import JapanFaq2 from '../Assets/ITALY/Career-Opportunities-in-italy.jpg'
import JapanFaq3 from '../Assets/ITALY/Long-Term-Prospects-in-Italy.jpg'
import JapanFaq4 from '../Assets/ITALY/Visa-Support-in-Italy.jpg'
import { Link } from "react-router-dom";

export const serviceData = [

{
  id: "USA",
  bannersubtitle: "Study in USA with Expert Guidance",
  bannertitleone: "Explore Study Abroad Programs in USA",
  bannertitletwo: "with Scholarships & Expert Consultancy",
  bannerbgimg: "/images/usa-banner.png",

  img1: first,
  img2: second,

  heading1: "Your Complete Guide to Study Abroad Programs in USA",
  para1: `For many international students, the dream to study in USA is not just about earning a degree, it’s about unlocking global opportunities. At Nova EduBridge, a trusted foreign study consultancy in USA, we guide you through the best study abroad programs in USA with a focus on affordability and quality. We help you explore scholarship abroad in USA options and identify the best programs that align with your career goals while ensuring access to scholarships for students in USA.`,

  heading2: "Affordable Study Abroad Programs in USA with Scholarships",
  para2: <>While many believe that study in USA is expensive, there are numerous <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}> study abroad programs in USA  </Link>   that offer affordable tuition and excellent scholarship abroad in USA opportunities. As a leading foreign study consultancy in USA, we provide access to top universities offering scholarships for students in USA across various programs. <br/><br/>
  Whether you are interested in artificial intelligence, data analytics, MBA, or healthcare management, we help you compare study abroad programs in USA based on cost, ROI, and available scholarships for students in USA, ensuring you make the right academic investment.</>,

  carouseltitle: "Top Study Abroad Programs in USA for Career Growth",
  carouselsubtitle: "Students choose study abroad programs in USA for high-demand fields such as:",

  carousellist: [
    {
      img: iot1,
      title: "Artificial Intelligence courses in USA",
      desc: "Explore study abroad programs in USA focused on AI and machine learning with scholarship abroad in USA opportunities."
    },
    {
      img: iot2,
      title: "Data analytics courses in USA",
      desc: "Gain in-demand skills through study abroad programs in USA with access to scholarships for students in USA."
    },
    {
      img: iot3,
      title: "MBA/MS in healthcare management in USA",
      desc: "Advance your career with specialized study abroad programs in USA supported by foreign study consultancy in USA."
    },
    {
      img: iot4,
      title: "Best online MBA/MS in USA",
      desc: "Flexible study abroad programs in USA designed for working professionals with scholarship abroad in USA options."
    },
  ],

  milestones: [
    {
      title: 'Jobs in America for International Graduates',
      content: {
        img: usafaq1,
        heading: 'Jobs After Study Abroad Programs in USA',
        text: <>After completing study abroad programs in USA, students gain access to excellent career opportunities. With the support of our foreign study consultancy in USA, you can explore job opportunities aligned with your education. <br/><br/>
        <b>Our career services include:</b><br/><br/>
        <ul>
          <li>Guidance for students who study in USA and want to build global careers.</li>
          <li>Strategies to secure jobs after completing study abroad programs in USA.</li>
          <li>Support for international students leveraging scholarships for students in USA.</li>
          <li>Insights into work opportunities after scholarship abroad in USA programs.</li>
        </ul>
        <p className="mt-3">We connect you with employers offering opportunities after study abroad programs in USA, ensuring a strong career start.</p>
        </>
      }
    },

    {
      title: 'Finding the Right Job Portals and Opportunities',
      content: {
        img: usafaq2,
        heading: 'Career Opportunities After Study in USA',
        text: <>Students who study in USA through structured study abroad programs in USA gain access to diverse industries. Our foreign study consultancy in USA helps you identify the right platforms and industries offering high-demand roles. <br/><br/>
        From technology to finance and healthcare, study abroad programs in USA combined with scholarships for students in USA open doors to global careers.</>
      }
    },

    {
      title: 'Balancing Study and Work in the USA',
      content: {
        img: usafaq3,
        heading: 'Work While Studying in USA',
        text: <>Many students pursuing study abroad programs in USA look for part-time work opportunities. While you study in USA, you can benefit from OPT and CPT programs that enhance your professional experience. <br/><br/>
        Students enrolled through a foreign study consultancy in USA often secure better opportunities with access to scholarship abroad in USA benefits and career pathways.</>
      }
    },

    {
      title: 'Post-Graduation Career Planning',
      content: {
        img: usafaq4,
        heading: 'Career Planning After Study Abroad Programs in USA',
        text: <>Completing study abroad programs in USA is the first step toward a successful career. With our foreign study consultancy in USA, we guide you in transitioning from education to employment. <br/><br/>
        <ul>
          <li>Career planning after study in USA</li>
          <li>Job support for students with scholarships for students in USA</li>
          <li>Guidance for long-term opportunities after scholarship abroad in USA</li>
          <li>End-to-end career support for study abroad programs in USA graduates</li>
        </ul>
        </>
      }
    },

    {
      title: 'Living and Thriving in America',
      content: {
        img: usafaq5,
        heading: 'Life After Study in USA',
        text: <>Beyond academics, study abroad programs in USA prepare you for global exposure. Our foreign study consultancy in USA ensures you adapt smoothly to life abroad. <br/><br/>
        From accommodation to lifestyle support, students who study in USA with scholarships for students in USA benefit from a well-rounded international experience.</>
      }
    },

    {
      title: 'Why Choose Nova EduBridge for Your USA Journey',
      content: {
        img: usafaq6,
        heading: 'Best Foreign Study Consultancy in USA',
        text: <>
        <ul>
          <li>Expert guidance for study abroad programs in USA</li>
          <li>Access to top universities with scholarships for students in USA</li>
          <li>Complete support from a trusted foreign study consultancy in USA</li>
          <li>Guidance on scholarship abroad in USA applications</li>
          <li>Career-focused approach for students planning to study in USA</li>
        </ul>
        <p>With the right strategy, study abroad programs in USA can transform your future. Whether you are looking for scholarships for students in USA or expert guidance from a foreign study consultancy in USA, Nova EduBridge is your trusted partner.</p>
        </>
      }
    }
  ]
},
 // Source: :contentReference[oaicite:0]{index=0}


{
  id: "UK",
  bannersubtitle: "UK Study for Indian Students with Expert Guidance",
  bannertitleone: "UK Study for Indian Students & Overseas Scholarship Support",
  bannertitletwo: "by Abroad Education Consultants Bangalore",
  bannerbgimg: "/images/UK-banner.png",

  img1: ukfirst,
  img2: uksecond,

  heading1: "UK Study for Indian Students with Scholarships",
  para1: <>The United Kingdom is one of the most preferred destinations for students planning higher education abroad. <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>UK study for Indian students</Link> offers globally recognized universities, diverse career opportunities, and cultural exposure. At Nova EduBridge, one of the trusted abroad education consultants Bangalore, we help you find low cost universities while guiding you through scholarships for Indian students in UK and overseas scholarship opportunities. <br/>
  Whether you are planning your masters or exploring top universities, we ensure you make the right academic and financial decision.</>,

  heading2: "Affordable UK Study for Indian Students with Overseas Scholarship",
  para2: <>While many assume studying abroad is expensive, UK study for Indian students can be affordable with the right overseas scholarship support. As experienced abroad education consultants Bangalore, we help you access scholarships for Indian students in UK across multiple universities.<br/><br/>
  From business and technology to healthcare and engineering, we guide you in selecting programs that offer strong ROI along with overseas scholarship benefits.</>,

  carouseltitle: "Top Courses for UK Study for Indian Students",
  carouselsubtitle: "Popular choices for UK study for Indian students include:",

  carousellist: [
    {
      img: ukcourse1,
      title: "Business and Management in UK",
      desc: "Top choice for UK study for Indian students with overseas scholarship opportunities."
    },
    {
      img: ukcourse2,
      title: "Data Science and Analytics in UK",
      desc: "High-demand field with scholarships for Indian students in UK."
    },
    {
      img: ukcourse3,
      title: "Engineering and Technology in UK",
      desc: "Advanced programs supported by abroad education consultants Bangalore."
    },
    {
      img: ukcourse4,
      title: "Healthcare and Life Sciences in UK",
      desc: "Strong career scope with overseas scholarship options."
    },
  ],

  milestones: [

    {
      title: 'Career Opportunities for Indian Students in UK',
      content: {
        img: ukfaq1,
        heading: 'Jobs After UK Study for Indian Students',
        text: <>After completing UK study for Indian students programs, graduates gain access to global career opportunities. With support from abroad education consultants Bangalore, you can explore roles aligned with your qualifications. <br/><br/>
        Students benefiting from scholarships for Indian students in UK and overseas scholarship programs often gain a competitive advantage in the job market.</>
      }
    },

    {
      title: 'Job Portals and Opportunities in UK',
      content: {
        img: ukfaq2,
        heading: 'Career Opportunities After UK Study for Indian Students',
        text: <>Choosing the right platform is key after completing UK study for Indian students programs. We help you access:<br/><br/>
        <ul>
          <li>Top job sites for Indian students in UK</li>
          <li>Recruitment agencies in London</li>
          <li>Industry-specific job portals</li>
        </ul>
        <p className="mt-3">Students with overseas scholarship experience and UK exposure stand out to employers.</p>
        </>
      }
    },

    {
      title: 'Career Planning for Indian Students in UK',
      content: {
        img: ukfaq3,
        heading: 'Career Planning After UK Study for Indian Students',
        text: <>Strategic planning is essential for success after UK study for Indian students. Our abroad education consultants Bangalore provide:<br/><br/>
        <ul>
          <li>CV and LinkedIn optimization</li>
          <li>Guidance for scholarships for Indian students in UK</li>
          <li>Industry insights and hiring trends</li>
          <li>Support for overseas scholarship career pathways</li>
        </ul>
        </>
      }
    },

    {
      title: 'Student Life in UK',
      content: {
        img: ukfaq4,
        heading: 'Life in UK for Indian Students',
        text: <>UK study for Indian students offers a rich cultural and academic experience. We prepare you for:<br/><br/>
        <ul>
          <li>Cost of living and budgeting</li>
          <li>Accommodation options</li>
          <li>Healthcare and insurance</li>
          <li>Cultural adaptation</li>
        </ul>
        <p>Students supported by abroad education consultants Bangalore enjoy a smooth transition abroad.</p>
        </>
      }
    },

    {
      title: 'Flexible Work Opportunities',
      content: {
        img: ukfaq5,
        heading: 'Work Opportunities for Indian Students in UK',
        text: <>Many students pursuing UK study for Indian students programs explore flexible and remote work options. These opportunities help build experience while studying.<br/><br/>
        With overseas scholarship support, students can focus on both academics and career growth.</>
      }
    },

    {
      title: 'Balancing Study and Work',
      content: {
        img: ukfaq6,
        heading: 'Work While Studying in UK for Indian Students',
        text: <>Students enrolled in UK study for Indian students programs can take up part-time work to support living expenses. This is especially beneficial for those using scholarships for Indian students in UK.<br/><br/>
        Work experience gained enhances employability after graduation.</>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: ukfaq7,
        heading: 'Best Abroad Education Consultants Bangalore for UK',
        text: <>
        <ul>
          <li>Expert guidance for UK study for Indian students</li>
          <li>Access to scholarships for Indian students in UK</li>
          <li>Complete overseas scholarship support</li>
          <li>Trusted abroad education consultants Bangalore</li>
          <li>End-to-end career and admission support</li>
        </ul>
        <p>With the right guidance, UK study for Indian students becomes affordable and career-focused. Whether you are looking for scholarships for Indian students in UK or overseas scholarship opportunities, Nova EduBridge ensures your success.</p>
        </>
      }
    }

  ]
},

  // Source: :contentReference[oaicite:0]{index=0}

{
  id: "Australia",
  bannersubtitle: "Study in Australia with Top Universities",
  bannertitleone: "Study in Australia for World-Class Education",
  bannertitletwo: "and Global Career Opportunities",
  bannerbgimg: "/images/Australia-banner.png",

  img1: australiafirst,
  img2: australiasecond,

  heading1: "Study in Australia – Best College in Australia & Top Universities",
  para1: <>Australia is one of the most preferred destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study in Australia</Link> due to its high-quality education system, global exposure, and career opportunities. 
  Choosing the best college in Australia or the right university in Australia can shape your future significantly. <br/><br/>
  At Nova EduBridge, we help you explore top universities and courses in Australia, ensuring you select the right academic path based on your career goals, including options like MBA in Australia and specialized programs.</>,

  heading2: "Courses in Australia & MBA in Australia for Global Careers",
  para2: <>When you study in Australia, you gain access to globally recognized degrees from top universities in Australia. From undergraduate to postgraduate programs, there are diverse courses in Australia designed to meet industry demands.<br/><br/>
  Whether you are planning for an MBA in Australia, technical courses, or healthcare programs, we guide you in selecting the best college in Australia that offers strong ROI, practical learning, and career growth opportunities.</>,

  carouseltitle: "Top Courses in Australia for Career Growth",
  carouselsubtitle: "Students who study in Australia can choose from popular courses in Australia such as:",

  carousellist: [
    {
      img: austcourse1,
      title: "Business and Management & MBA in Australia",
      desc: "Study in Australia with top universities offering MBA in Australia and business programs."
    },
    {
      img: austcourse2,
      title: "Information Technology Courses in Australia",
      desc: "High-demand courses in Australia offered by leading universities in Australia."
    },
    {
      img: austcourse3,
      title: "Engineering Courses in Australia",
      desc: "Advanced programs in the best college in Australia with global recognition."
    },
    {
      img: austcourse4,
      title: "Healthcare and Nursing in Australia",
      desc: "Top courses in Australia for students aiming for global healthcare careers."
    },
    {
      img: austcourse5,
      title: "Environmental Science in Australia",
      desc: "Sustainable and innovative courses in Australia offered by top universities."
    },
    {
      img: austcourse6,
      title: "Creative Arts in Australia",
      desc: "Explore creative courses in Australia at the best colleges in Australia."
    },
  ],

  milestones: [

    {
      title: 'Work Opportunities While You Study in Australia',
      content: {
        img: austfaq1,
        heading: 'Work While Studying in Australia',
        text: <>Students who study in Australia can work part-time while pursuing courses in Australia. This helps manage living expenses and gain practical experience.<br/><br/>
        Studying at the best college in Australia or a reputed university in Australia increases your chances of securing internships and industry exposure.</>
      }
    },

    {
      title: 'Jobs After Studying in Australia',
      content: {
        img: austfaq2,
        heading: 'Career Opportunities After Study in Australia',
        text: <>After completing courses in Australia, students can explore job opportunities across industries like IT, healthcare, finance, and engineering.<br/><br/>
        Graduates from top universities in Australia and MBA in Australia programs often secure high-paying roles globally.</>
      }
    },

    {
      title: 'Post-Study Work Opportunities in Australia',
      content: {
        img: austfaq3,
        heading: 'Post-Study Work After Study in Australia',
        text: <>Australia offers excellent post-study work opportunities for students completing courses in Australia. Depending on your qualification, you may stay and work for 2–4 years.<br/><br/>
        This allows students from the best college in Australia to gain international experience and build strong careers.</>
      }
    },

    {
      title: 'High-Demand Courses in Australia',
      content: {
        img: austfaq4,
        heading: 'Top Courses in Australia with High Demand',
        text: <>
        <ul>
          <li>IT and Software Development</li>
          <li>Healthcare and Nursing</li>
          <li>Engineering Programs</li>
          <li>Business and MBA in Australia</li>
          <li>Data Science and Analytics</li>
        </ul>
        <p>Choosing the right courses in Australia from a top university in Australia improves your career prospects significantly.</p>
        </>
      }
    },

    {
      title: 'Finding the Right University in Australia',
      content: {
        img: austfaq5,
        heading: 'Best College in Australia & University Selection',
        text: <>Selecting the best college in Australia or the right university in Australia is crucial for your success. We help you compare universities based on rankings, fees, courses in Australia, and career outcomes.<br/><br/>
        Our guidance ensures you choose the best fit for your academic and professional goals.</>
      }
    },

    {
      title: 'Australia Job Market Insights',
      content: {
        img: austfaq6,
        heading: 'Job Opportunities After Courses in Australia',
        text: <>The job market in Australia is dynamic, with opportunities across major cities like Sydney, Melbourne, and Brisbane.<br/><br/>
        Students completing courses in Australia from top universities in Australia often find strong demand in their respective industries.</>
      }
    },

    {
      title: 'Life in Australia for Students',
      content: {
        img: austfaq7,
        heading: 'Student Life While You Study in Australia',
        text: <>When you study in Australia, you experience a high quality of life, multicultural environment, and global exposure.<br/><br/>
        Students studying in the best college in Australia enjoy world-class infrastructure, safety, and vibrant campus life.</>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: austfaq8,
        heading: 'Best Guidance to Study in Australia',
        text: <>
        <ul>
          <li>Expert support to study in Australia</li>
          <li>Guidance to choose the best college in Australia</li>
          <li>Access to top universities in Australia</li>
          <li>Career-focused courses in Australia</li>
          <li>Specialized guidance for MBA in Australia</li>
        </ul>
        <p>Whether you want to study in Australia, choose the best college in Australia, or pursue MBA in Australia, Nova EduBridge provides complete support to help you achieve your goals.</p>
        </>
      }
    }

  ]
},

{
  id: "Canada",
  bannersubtitle: "Study Abroad in Canada ",
  bannertitleone: "Study in Canada with Expert Guidance,",
  bannertitletwo: "Scholarships, and Visa Support",
  bannerbgimg: "/images/Canada-banner.png",

  img1: canadafirst,
  img2: canadasecond,

  heading1: "Study Abroad in Canada – Best Countries to Study Abroad",
  para1: <>Canada is recognized as one of the best countries to study abroad, offering world-class education and excellent career opportunities. Students choosing to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Canada</Link> benefit from globally recognized degrees, multicultural exposure, and strong career prospects. <br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting the right university to building a successful career abroad in Canada. As a trusted student visa consultant for Canada, we also assist with visa processing and help you access scholarship in Canada opportunities.</>,

  heading2: "Scholarship in Canada & Student Visa Consultant for Canada",
  para2: <>Pursuing study abroad in Canada becomes more accessible with the right guidance and financial planning. There are multiple scholarship in Canada options available for international students, making it easier to manage tuition and living expenses.<br/><br/>
  As an experienced student visa consultant for Canada, we provide complete support—from selecting the right course to applying for visas and scholarships. Our goal is to help you build a strong foundation for a successful career abroad in Canada.</>,

  carouseltitle: "Why Study Abroad in Canada?",
  carouselsubtitle: "Canada is one of the best countries to study abroad because of:",

  carousellist: [
    {
      img: canadacourse1,
      title: "Top Universities in Canada",
      desc: "Study abroad in Canada with globally ranked institutions and quality education."
    },
    {
      img: canadacourse2,
      title: "Strong Career Opportunities",
      desc: "Build a career abroad in Canada with high employment rates across industries."
    },
    {
      img: canadacourse3,
      title: "Pathways to Permanent Residency",
      desc: "Study abroad in Canada and transition into long-term settlement opportunities."
    },
    {
      img: canadacourse4,
      title: "High Quality of Life",
      desc: "One of the best countries to study abroad with safety, healthcare, and lifestyle benefits."
    },
  ],

  milestones: [

    {
      title: 'Study Abroad in Canada – Build Your Future',
      content: {
        img: canadafaq1,
        heading: 'Study Abroad in Canada with Scholarship Opportunities',
        text: <>
        <b>Choosing to study abroad in Canada opens doors to global opportunities. With access to scholarship in Canada programs, students can achieve quality education affordably.</b><br/><br/>
        <ul>
          <li>University & course selection</li>
          <li>Application assistance</li>
          <li>Support from student visa consultant for Canada</li>
          <li>Pre-departure guidance</li>
        </ul>
        <br/>
        <p>Students can also work part-time while studying, gaining experience and preparing for a career abroad in Canada.</p>
        </>
      }
    },

    {
      title: 'Career Abroad in Canada',
      content: {
        img: canadafaq2,
        heading: 'Career Abroad in Canada Opportunities',
        text: <>
        <b>Canada offers excellent opportunities for building a career abroad in Canada across industries such as IT, healthcare, engineering, and finance.</b><br/><br/>
        <ul>
          <li>High-demand job sectors</li>
          <li>Competitive salaries</li>
          <li>Opportunities after study abroad in Canada</li>
        </ul>
        <br/>
        <p>We guide you in securing jobs and building a long-term career abroad in Canada.</p>
        </>
      }
    },

    {
      title: 'Jobs in Canada for International Students',
      content: {
        img: canadafaq3,
        heading: 'Jobs After Study Abroad in Canada',
        text: <>
        Students who study abroad in Canada can explore multiple job opportunities after graduation.<br/><br/>
        <ul>
          <li>Resume and job application support</li>
          <li>Access to employers and recruiters</li>
          <li>Guidance for career abroad in Canada</li>
        </ul>
        <br/>
        <p>We ensure you transition smoothly from student life to professional success.</p>
        </>
      }
    },

    {
      title: 'Student Visa Consultant for Canada',
      content: {
        img: canadafaq4,
        heading: 'Expert Student Visa Consultant for Canada',
        text: <>
        <b>Getting your visa approved is a crucial step in your journey to study abroad in Canada.</b><br/><br/>
        <ul>
          <li>Complete visa documentation support</li>
          <li>Guidance on visa types</li>
          <li>Application review and submission</li>
        </ul>
        <br/>
        <p>As a trusted student visa consultant for Canada, we ensure a smooth and successful visa process.</p>
        </>
      }
    },

    {
      title: 'Scholarship in Canada',
      content: {
        img: canadafaq5,
        heading: 'Scholarship in Canada for International Students',
        text: <>
        Many students choose study abroad in Canada due to the availability of scholarship in Canada programs.<br/><br/>
        <ul>
          <li>Merit-based scholarships</li>
          <li>University-specific funding</li>
          <li>Government scholarships</li>
        </ul>
        <br/>
        <p>We help you apply and maximize your chances of receiving scholarship in Canada.</p>
        </>
      }
    },

    {
      title: 'Life & Career Growth in Canada',
      content: {
        img: canadafaq6,
        heading: 'Life After Study Abroad in Canada',
        text: <>
        Living in Canada offers a high standard of living, multicultural environment, and long-term growth opportunities.<br/><br/>
        <ul>
          <li>Career abroad in Canada pathways</li>
          <li>PR opportunities</li>
          <li>Work-life balance</li>
        </ul>
        </>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: canadafaq7,
        heading: 'Best Support for Study Abroad in Canada',
        text: <>
        <ul>
          <li>Expert guidance for study abroad in Canada</li>
          <li>Support from student visa consultant for Canada</li>
          <li>Access to scholarship in Canada opportunities</li>
          <li>Career-focused approach for career abroad in Canada</li>
          <li>End-to-end admission and visa support</li>
        </ul>
        <p>Whether you want to study abroad in Canada, build a career abroad in Canada, or explore one of the best countries to study abroad, Nova EduBridge is your trusted partner.</p>
        </>
      }
    }

  ]
},


{
  id: "NewZealand",
  bannersubtitle: "Study Abroad in New Zealand ",
  bannertitleone: "Study in New Zealand with Affordable Education",
  bannertitletwo: "and Expert Student Visa Guidance",
  bannerbgimg: "/images/Zewzealand-banner.png",

  img1: newfirst,
  img2: newsecond,

  heading1: "Study Abroad in New Zealand for International Students",
  para1: <>New Zealand is becoming one of the most preferred destinations for students looking to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study in New Zealand</Link> due to its high-quality education system and global career opportunities. The country is home to top universities in New Zealand for international students offering industry-focused programs and practical learning. <br/><br/>
  At Nova EduBridge, we guide you in selecting the right universities in New Zealand for international students, understanding the cost of studying in New Zealand, and providing complete New Zealand student visa guidance for a smooth admission process.</>,

  heading2: "Top Courses in New Zealand Universities & Cost of Studying in New Zealand",
  para2: <>When you choose to study abroad in New Zealand, you gain access to top courses in New Zealand universities across various fields such as business, engineering, healthcare, and IT. These programs are designed to meet global industry standards and enhance employability.<br/><br/>
  We also help you understand the cost of studying in New Zealand, including tuition fees, living expenses, and financial planning, while offering complete New Zealand student visa guidance to ensure a hassle-free journey.</>,

  carouseltitle: "Top Courses in New Zealand Universities",
  carouselsubtitle: "Students choosing to study abroad in New Zealand can explore:",

  carousellist: [
    {
      img: newcourse1,
      title: "Business & Management Courses",
      desc: "Top courses in New Zealand universities with global career opportunities."
    },
    {
      img: newcourse2,
      title: "Information Technology Programs",
      desc: "High-demand courses offered by universities in New Zealand for international students."
    },
    {
      img: newcourse3,
      title: "Engineering & Construction",
      desc: "Advanced programs in top universities in New Zealand for international students."
    },
    {
      img: newcourse4,
      title: "Healthcare & Life Sciences",
      desc: "Leading courses in New Zealand universities with strong career prospects."
    },
  ],

  milestones: [

    {
      title: 'Study Abroad in New Zealand – Academic Excellence',
      content: {
        img: newfaq1,
        heading: 'Study Abroad in New Zealand with Top Universities',
        text: <>
        <b>Choosing to study abroad in New Zealand gives you access to globally recognized degrees from universities in New Zealand for international students.</b><br/><br/>
        <ul>
          <li>Globally recognized qualifications</li>
          <li>Hands-on learning experience</li>
          <li>Strong student support systems</li>
          <li>Safe and inclusive environment</li>
        </ul>
        <br/>
        <p>We help you select the right university and provide complete New Zealand student visa guidance.</p>
        </>
      }
    },

    {
      title: 'Career Opportunities in New Zealand',
      content: {
        img: newfaq2,
        heading: 'Career Opportunities After Study Abroad in New Zealand',
        text: <>
        Students completing study abroad in New Zealand programs can explore strong career opportunities across industries such as IT, healthcare, engineering, and agriculture.<br/><br/>
        Graduates from universities in New Zealand for international students are highly valued in the global job market.
        </>
      }
    },

    {
      title: 'Jobs in New Zealand for International Students',
      content: {
        img: newfaq3,
        heading: 'Jobs After Studying in New Zealand',
        text: <>
        Students who study abroad in New Zealand can access various job opportunities during and after their studies.<br/><br/>
        <ul>
          <li>Part-time work during studies</li>
          <li>Full-time opportunities after graduation</li>
          <li>Career support and job guidance</li>
        </ul>
        </>
      }
    },

    {
      title: 'Work Opportunities in New Zealand',
      content: {
        img: newfaq4,
        heading: 'Work While Studying in New Zealand',
        text: <>
        Students enrolled in top courses in New Zealand universities can work part-time while studying. This helps manage the cost of studying in New Zealand and gain practical experience.<br/><br/>
        Work experience improves career opportunities after graduation.
        </>
      }
    },

    {
      title: 'New Zealand Hiring Trends',
      content: {
        img: newfaq5,
        heading: 'High-Demand Courses in New Zealand Universities',
        text: <>
        The demand for skilled professionals in New Zealand continues to grow. Students choosing top courses in New Zealand universities have better career prospects.<br/><br/>
        <ul>
          <li>IT and Software Development</li>
          <li>Healthcare and Nursing</li>
          <li>Engineering and Construction</li>
          <li>Agriculture and Environmental Sciences</li>
        </ul>
        </>
      }
    },

    {
      title: 'New Zealand Student Visa Guidance',
      content: {
        img: newfaq6,
        heading: 'Complete New Zealand Student Visa Guidance',
        text: <>
        <b>Getting your visa approved is a crucial step to study abroad in New Zealand.</b><br/><br/>
        <ul>
          <li>Student visa documentation support</li>
          <li>Application assistance</li>
          <li>Compliance with immigration rules</li>
        </ul>
        <br/>
        <p>Our New Zealand student visa guidance ensures a smooth and successful visa process.</p>
        </>
      }
    },

    {
      title: 'Cost of Studying in New Zealand',
      content: {
        img: newfaq7,
        heading: 'Understanding Cost of Studying in New Zealand',
        text: <>
        The cost of studying in New Zealand includes tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively so you can study abroad in New Zealand without stress.
        </>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: newfaq8,
        heading: 'Best Guidance to Study Abroad in New Zealand',
        text: <>
        <ul>
          <li>Expert support for study abroad in New Zealand</li>
          <li>Access to top universities in New Zealand for international students</li>
          <li>Guidance on top courses in New Zealand universities</li>
          <li>Complete New Zealand student visa guidance</li>
          <li>Support in managing cost of studying in New Zealand</li>
        </ul>
        <p>Whether you want to study abroad in New Zealand, choose from the best universities in New Zealand for international students, or understand the cost of studying in New Zealand, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},



// Source: :contentReference[oaicite:0]{index=0}

{
  id: "Ireland",
  bannersubtitle: "Study in Ireland for Global Opportunities",

  // ✅ Single meaningful heading (split styling ready)
  bannertitleone: "Study in Ireland with Top Universities and",
  bannertitletwo: "Scholarships for Indian Students & Career Opportunities",

  bannerbgimg: "/images/Ireland-banner.png",

  img1: irelandfirst,
  img2: irelandsecond,

  heading1: "Study in Ireland for International Students",
  para1: <>Ireland has become one of the most preferred destinations for students looking to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study in Ireland</Link> due to its high-quality education system and strong career prospects. The country is home to top universities in Ireland for international students offering globally recognized degrees and industry-focused learning. <br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting the right universities in Ireland for international students to helping you access scholarships for Indian students in Ireland and planning your long-term career path.</>,

  heading2: "Top Courses in Ireland Universities & Scholarships for Indian Students",
  para2: <>Students who choose to study in Ireland can explore a wide range of top courses in Ireland universities across fields like IT, business, healthcare, engineering, and data science.<br/><br/>
  We also help you secure scholarships for Indian students in Ireland, making education more affordable while ensuring you gain access to the best academic and career opportunities.</>,

  carouseltitle: "Top Courses in Ireland Universities",
  carouselsubtitle: "Popular options for students who study in Ireland include:",

  carousellist: [
    {
      img: irelandcourse1,
      title: "Computer Science & IT in Ireland",
      desc: "Top courses in Ireland universities with strong job demand."
    },
    {
      img: irelandcourse2,
      title: "Business & Management in Ireland",
      desc: "Highly preferred programs for students pursuing study in Ireland."
    },
    {
      img: irelandcourse3,
      title: "Engineering & Data Analytics",
      desc: "Advanced programs in top universities in Ireland for international students."
    },
    {
      img: irelandcourse4,
      title: "Healthcare & Pharmaceutical Sciences",
      desc: "Leading courses in Ireland universities with global career scope."
    },
  ],

  milestones: [

    {
      title: 'Study in Ireland – Academic Excellence',
      content: {
        img: irelandfaq1,
        heading: 'Study in Ireland with Top Universities',
        text: <>
        <b>Choosing to study in Ireland gives you access to globally recognized education from universities in Ireland for international students.</b><br/><br/>
        <ul>
          <li>Industry-focused learning</li>
          <li>Research-driven programs</li>
          <li>Strong academic support</li>
          <li>Global career exposure</li>
        </ul>
        <br/>
        <p>We help you choose from the best universities in Ireland for international students based on your goals.</p>
        </>
      }
    },

    {
      title: 'Universities in Ireland for International Students',
      content: {
        img: irelandfaq2,
        heading: 'Top Universities in Ireland for International Students',
        text: <>
        Students choosing to study in Ireland benefit from world-class institutions with strong industry connections.<br/><br/>
        Many universities also offer scholarships for Indian students in Ireland, making education more accessible and affordable.
        </>
      }
    },

    {
      title: 'Post-Study Work Opportunities in Ireland',
      content: {
        img: irelandfaq3,
        heading: 'Post-Study Work Opportunities in Ireland',
        text: <>
        One of the biggest advantages of choosing to study in Ireland is access to post-study work opportunities in Ireland.<br/><br/>
        Graduates can stay back and work for up to 2 years, gaining valuable international work experience and building long-term careers.
        </>
      }
    },

    {
      title: 'Career Opportunities in Ireland',
      content: {
        img: irelandfaq4,
        heading: 'Career Opportunities After Study in Ireland',
        text: <>
        Students graduating from top courses in Ireland universities can explore career opportunities across sectors like IT, finance, healthcare, and engineering.<br/><br/>
        Ireland’s strong economy and presence of multinational companies create excellent job prospects.
        </>
      }
    },

    {
      title: 'Scholarships for Indian Students in Ireland',
      content: {
        img: irelandfaq5,
        heading: 'Scholarships for Indian Students in Ireland',
        text: <>
        Many students choose to study in Ireland due to the availability of scholarships for Indian students in Ireland.<br/><br/>
        <ul>
          <li>Merit-based scholarships</li>
          <li>University-specific funding</li>
          <li>Government scholarships</li>
        </ul>
        <br/>
        <p>We guide you through the application process to maximize your chances of receiving scholarships.</p>
        </>
      }
    },

    {
      title: 'Work While Studying in Ireland',
      content: {
        img: irelandfaq6,
        heading: 'Work While Studying in Ireland',
        text: <>
        Students who study in Ireland can work part-time during their studies, helping manage expenses and gain experience.<br/><br/>
        This also improves employability after graduation.
        </>
      }
    },

    {
      title: 'Visa Guidance for Ireland',
      content: {
        img: irelandfaq7,
        heading: 'Student Visa Guidance for Ireland',
        text: <>
        <b>Getting your visa approved is a key step to study in Ireland.</b><br/><br/>
        <ul>
          <li>Complete documentation support</li>
          <li>Application guidance</li>
          <li>Visa interview preparation</li>
        </ul>
        <br/>
        <p>We ensure a smooth visa process so you can focus on your education.</p>
        </>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: irelandfaq8,
        heading: 'Best Guidance to Study in Ireland',
        text: <>
        <ul>
          <li>Expert support for study in Ireland</li>
          <li>Access to top universities in Ireland for international students</li>
          <li>Guidance on top courses in Ireland universities</li>
          <li>Support for scholarships for Indian students in Ireland</li>
          <li>Career guidance with post-study work opportunities in Ireland</li>
        </ul>
        <p>Whether you want to study in Ireland, explore top universities in Ireland for international students, or benefit from post-study work opportunities in Ireland, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    },

    {
      title: 'Start Your Ireland Journey',
      content: {
        img: irelandfaq9,
        heading: 'Start Your Journey to Study in Ireland',
        text: <>
        <p>Your journey to study in Ireland begins with the right guidance. From selecting universities in Ireland for international students to securing scholarships for Indian students in Ireland, we are here to support you.</p>
        <p>Take the first step today and build your future with confidence.</p>
        </>
      }
    }

  ]
},


// Source: :contentReference[oaicite:0]{index=0}

{
  id: "Germany",
  bannersubtitle: "Study in Germany for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Germany with Top Universities and",
  bannertitletwo: "Student Visa Guidance & Career Opportunities",

  bannerbgimg: "/images/Germany-banner.png",

  img1: germanyfirst,
  img2: germanysecond,

  heading1: "Study in Germany for International Students",
  para1: <>Germany is one of the most preferred destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Germany</Link> due to its world-class education system and affordable tuition fees. The country is home to top universities in Germany for international students offering globally recognized degrees and strong industry connections. <br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Germany for international students to understanding Germany student visa requirements and planning your academic journey.</>,

  heading2: "Top Courses in German Universities & Germany Student Visa Requirements",
  para2: <>Students who choose to study in Germany can explore a wide range of top courses in German universities including engineering, IT, business, healthcare, and data science.<br/><br/>
  We also provide complete guidance on Germany student visa requirements, ensuring a smooth admission and visa process while helping you plan your education effectively.</>,

  carouseltitle: "Top Courses in German Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Germany include:",

  carousellist: [
    {
      img: germanycourse1,
      title: "Engineering in Germany",
      desc: "Top courses in German universities with strong global demand."
    },
    {
      img: germanycourse2,
      title: "Information Technology in Germany",
      desc: "High-demand programs offered by universities in Germany for international students."
    },
    {
      img: germanycourse3,
      title: "Business & Management in Germany",
      desc: "Leading programs for students planning to study in Germany."
    },
    {
      img: germanycourse4,
      title: "Healthcare & Life Sciences",
      desc: "Advanced courses in German universities with strong career prospects."
    },
  ],

  milestones: [

    {
      title: 'Study Abroad in Germany – Academic Excellence',
      content: {
        img: germanyfaq1,
        heading: 'Study Abroad in Germany with Top Universities',
        text: <>
        <b>Choosing to study abroad in Germany gives you access to globally recognized education from universities in Germany for international students.</b><br/><br/>
        <ul>
          <li>Affordable or low tuition fees</li>
          <li>Industry-focused programs</li>
          <li>Strong research opportunities</li>
          <li>Global career exposure</li>
        </ul>
        <br/>
        <p>We help you select the best universities in Germany for international students based on your goals.</p>
        </>
      }
    },

    {
      title: 'Universities in Germany for International Students',
      content: {
        img: germanyfaq2,
        heading: 'Top Universities in Germany for International Students',
        text: <>
        Germany is home to some of the world’s leading institutions offering high-quality education.<br/><br/>
        Students planning to study in Germany can choose from a wide range of universities in Germany for international students known for academic excellence and global recognition.
        </>
      }
    },

    {
      title: 'Top Courses in German Universities',
      content: {
        img: germanyfaq3,
        heading: 'Top Courses in German Universities',
        text: <>
        Students who study abroad in Germany can choose from a variety of top courses in German universities such as:<br/><br/>
        <ul>
          <li>Engineering and Automotive Technology</li>
          <li>Computer Science and Artificial Intelligence</li>
          <li>Business and Management</li>
          <li>Renewable Energy and Environmental Science</li>
        </ul>
        </>
      }
    },

    {
      title: 'Career Opportunities in Germany',
      content: {
        img: germanyfaq4,
        heading: 'Career Opportunities After Study in Germany',
        text: <>
        Students graduating from universities in Germany for international students can explore career opportunities across industries like IT, engineering, healthcare, and finance.<br/><br/>
        Germany’s strong economy ensures excellent job prospects for international graduates.
        </>
      }
    },

    {
      title: 'Work Opportunities in Germany',
      content: {
        img: germanyfaq5,
        heading: 'Work While Studying in Germany',
        text: <>
        Students who study in Germany can work part-time while pursuing their education, helping manage expenses and gain practical experience.<br/><br/>
        This enhances employability after completing top courses in German universities.
        </>
      }
    },

    {
      title: 'Germany Student Visa Requirements',
      content: {
        img: germanyfaq6,
        heading: 'Germany Student Visa Requirements',
        text: <>
        <b>Understanding Germany student visa requirements is essential to study abroad in Germany.</b><br/><br/>
        <ul>
          <li>Valid admission letter from a university</li>
          <li>Proof of financial resources</li>
          <li>Health insurance</li>
          <li>Valid passport and documents</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure your visa application is smooth and successful.</p>
        </>
      }
    },

    {
      title: 'Post-Study Opportunities in Germany',
      content: {
        img: germanyfaq7,
        heading: 'Post-Study Work Opportunities in Germany',
        text: <>
        After completing your studies, you can stay in Germany to explore job opportunities and build a career.<br/><br/>
        Graduates from top courses in German universities benefit from strong employment prospects.
        </>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: germanyfaq8,
        heading: 'Best Guidance to Study Abroad in Germany',
        text: <>
        <ul>
          <li>Expert support for study abroad in Germany</li>
          <li>Access to top universities in Germany for international students</li>
          <li>Guidance on top courses in German universities</li>
          <li>Complete Germany student visa requirements support</li>
          <li>Career-focused education planning</li>
        </ul>
        <p>Whether you want to study in Germany, choose from the best universities in Germany for international students, or understand Germany student visa requirements, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},
// Source: :contentReference[oaicite:0]{index=0}

{
  id: "France",
  bannersubtitle: "Study in France for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in France with Top Universities and",
  bannertitletwo: "Student Visa Guidance & Career Opportunities",

  bannerbgimg: "/images/France-banner.png",

  img1: francefirst,
  img2: francesecond,

  heading1: "Study in France for International Students",
  para1: <>France is one of the most preferred destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in France</Link> due to its world-class education system and rich cultural experience. The country offers access to top universities in France for international students with globally recognized degrees and strong industry connections. <br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting the right universities in France for international students to understanding France student visa requirements and planning your academic journey.</>,

  heading2: "Top Courses in French Universities & France Student Visa Requirements",
  para2: <>Students who choose to study in France can explore a wide range of top courses in French universities including business, fashion, engineering, hospitality, and data science.<br/><br/>
  We also provide complete guidance on France student visa requirements, ensuring a smooth admission and visa process while helping you plan your education effectively.</>,

  carouseltitle: "Top Courses in French Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in France include:",

  carousellist: [
    {
      img: francecourse1,
      title: "Business & Management in France",
      desc: "Top courses in French universities with global career opportunities."
    },
    {
      img: francecourse2,
      title: "Fashion & Design in France",
      desc: "World-renowned programs in top universities in France for international students."
    },
    {
      img: francecourse3,
      title: "Engineering & Technology in France",
      desc: "Advanced programs with strong industry demand."
    },
    {
      img: francecourse4,
      title: "Hospitality & Tourism in France",
      desc: "Leading courses aligned with global hospitality standards."
    },
  ],

  milestones: [

    {
      title: 'Study Abroad in France – Academic Excellence',
      content: {
        img: francefaq1,
        heading: 'Study Abroad in France with Top Universities',
        text: <>
        <b>Choosing to study abroad in France gives you access to globally recognized education from universities in France for international students.</b><br/><br/>
        <ul>
          <li>Affordable tuition compared to other countries</li>
          <li>Industry-focused programs</li>
          <li>Research and internship opportunities</li>
          <li>Global career exposure</li>
        </ul>
        <br/>
        <p>We help you choose the best universities in France for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: 'Universities in France for International Students',
      content: {
        img: francefaq2,
        heading: 'Top Universities in France for International Students',
        text: <>
        France is home to some of the world’s leading institutions offering high-quality education.<br/><br/>
        Students planning to study in France can choose from top universities in France for international students known for academic excellence and global recognition.
        </>
      }
    },

    {
      title: 'Top Courses in French Universities',
      content: {
        img: francefaq3,
        heading: 'Top Courses in French Universities',
        text: <>
        Students who study abroad in France can choose from a variety of top courses in French universities such as:<br/><br/>
        <ul>
          <li>Business and Management</li>
          <li>Fashion and Luxury Brand Management</li>
          <li>Engineering and Technology</li>
          <li>Hospitality and Tourism</li>
        </ul>
        </>
      }
    },

    {
      title: 'Career Opportunities in France',
      content: {
        img: francefaq4,
        heading: 'Career Opportunities After Study in France',
        text: <>
        Students graduating from universities in France for international students can explore career opportunities across industries like fashion, IT, finance, and hospitality.<br/><br/>
        France’s strong economy offers excellent job prospects for international graduates.
        </>
      }
    },

    {
      title: 'Work Opportunities in France',
      content: {
        img: francefaq5,
        heading: 'Work While Studying in France',
        text: <>
        Students who study in France can work part-time while pursuing their education, helping manage expenses and gain practical experience.<br/><br/>
        This improves employability after completing top courses in French universities.
        </>
      }
    },

    {
      title: 'France Student Visa Requirements',
      content: {
        img: francefaq6,
        heading: 'France Student Visa Requirements',
        text: <>
        <b>Understanding France student visa requirements is essential to study abroad in France.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Proof of financial support</li>
          <li>Valid passport and documents</li>
          <li>Health insurance coverage</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure your visa process is smooth and successful.</p>
        </>
      }
    },

    {
      title: 'Post-Study Opportunities in France',
      content: {
        img: francefaq7,
        heading: 'Post-Study Work Opportunities in France',
        text: <>
        After completing your studies, you can explore job opportunities and build your career in France.<br/><br/>
        Graduates from top courses in French universities benefit from strong employment opportunities.
        </>
      }
    },

    {
      title: 'Why Choose Nova EduBridge',
      content: {
        img: francefaq8,
        heading: 'Best Guidance to Study Abroad in France',
        text: <>
        <ul>
          <li>Expert support for study abroad in France</li>
          <li>Access to top universities in France for international students</li>
          <li>Guidance on top courses in French universities</li>
          <li>Complete France student visa requirements support</li>
          <li>Career-focused education planning</li>
        </ul>
        <p>Whether you want to study in France, choose from the best universities in France for international students, or understand France student visa requirements, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},
  {
    id: "Europe",
    bannersubtitle: "Study in Europe",
    bannertitleone: "Nova EduBridge – Study and ",
    bannertitletwo: "Work in Europe",
    bannerbgimg: "/images/Europe-banner.png",
    img1: europefirst,
    img2: europesecond,
    heading1: "Study in Europe – Your Pathway to World-Class Education and Global Careers",
    para1: <>Europe has long been the dream destination for ambitious students and professionals from around the globe. 
    Whether your goal is to pursue higher education at some of the top universities in Europe for international students or to find a job in Europe that 
    matches your skills, the continent offers endless opportunities. Known for its academic excellence, 
    cultural diversity, and economic strength, Europe is the place where education meets career success, and where a single decision to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study in Europe</Link> can open doors to an entire continent.</> ,
     heading2: "Why Choose Europe for Your Studies?",
    para2: <>When you study in Europe for international students, you step into a world that blends history, innovation, and practical learning. European universities consistently rank among the best globally, offering a wide range of courses in English and other languages. From STEM programs in Germany to art and design courses in Italy, and from business schools in France to medical universities in Eastern Europe, the academic choices are limitless.A major advantage is that once you enroll in a University in Europe for international students, you often gain access to study and work rights, internships, and post-study work visas. This not only allows you to complete your degree but also makes it easier to work anywhere in Europe after graduation.
    </>,
    carouseltitle: "How to Get Started",
    carouselsubtitle: "Your journey to study in Europe begins with research and preparation:",
      carousellist: [
    {
        img: europecourse1,
        title: "Choose Your Country and Program",
        desc: "Decide which country matches your academic and lifestyle goals."
    },
    {
        img: europecourse2,
        title: "Check Entry Requirements",
        desc: "Review language tests, academic qualifications, and visa rules."
    },
    {
        img: europecourse3,
        title: "Apply to Universities in Europe for International Students",
        desc: "Prepare your applications with transcripts, recommendation letters, and a strong statement of purpose."
    },
    {
        img: europecourse4,
        title: "Secure Scholarships and Funding",
        desc: "Apply early for grants that can make studying abroad more affordable."
    },
    {
        img: europecourse5,
        title: "Prepare for Life Abroad",
        desc: "Arrange housing, health insurance, and familiarize yourself with the local culture."
    },
    ],
    milestones: [
      {
        title: 'Work Opportunities – Build Your Career While Studying',
        content: {
          img: europefaq1, // Replace with your actual image path
          heading: 'Work Opportunities – Build Your Career While Studying',
          text:  <><b>Europe is one of the easiest places to combine academic learning with work experience. Many countries allow part-time jobs for students, meaning you can work in Europe while you study to help with expenses and gain valuable international work exposure. Whether you’re exploring remote jobs in Europe, in-demand tech positions, or on-site roles in industries like engineering, healthcare, or hospitality, the job market is strong and welcoming to global talent.</b><br/><br/>
    <br/><br/>
    <p>Graduates also enjoy exceptional career prospects, thanks to Europe’s open employment policies between member states. For instance, if you complete your studies in Germany or France, you can apply for jobs in Spain, the Netherlands, or any other EU country without additional visas. This freedom makes Europe a top choice for those seeking careers in Europe after their studies.</p>
    </>
        }
      },
      {
        title: 'Affordable Education and Scholarships',
        content: {
          img: europefaq2,
          heading: 'Affordable Education and Scholarships',
          text:  <><b>Contrary to popular belief, studying in Europe doesn’t have to break the bank. Many European countries offer tuition-free or low-cost education, especially for EU students, but even non-EU students can find affordable programs. Countries like Germany, Norway, and Austria have little to no tuition fees for public universities, while France and Italy offer high-quality education at reasonable costs.</b><br/><br/>
    <br/><br/>
    <p>Moreover, there are numerous scholarships available for study in Europe for international students, covering tuition, accommodation, and even travel expenses. Programs like Erasmus+, DAAD, and national government scholarships make it easier for international students to access top-quality education.</p>
    </>
        }
      },
      {
        title: 'Living and Experiencing Europe',
        content: {
          img: europefaq3,
          heading: 'Living and Experiencing Europe',
          text:  <><b>Choosing to study abroad in Europe means immersing yourself in rich cultures, world-famous landmarks, and a lifestyle that blends tradition with modernity. From the Eiffel Tower in Paris to the canals of Amsterdam, from Prague’s old town charm to the beaches of Spain, every weekend can be a new adventure.</b><br/><br/>
    <br/><br/>
    Multilingual environments also make Europe ideal for personal growth. Many international students pick up additional languages, increasing their employability and cultural adaptability. And with budget airlines, train networks, and student discounts, traveling within Europe is both affordable and convenient.
    </>
        }
      },
      {
        title: 'High-Demand Job Sectors',
        content: {
          img: europefaq4,
          heading: 'High-Demand Job Sectors',
          text: <><b>If you plan to find a job in Europe after your studies, it’s important to know where opportunities are booming. Technology, renewable energy, engineering, finance, healthcare, and digital marketing are some of the fastest-growing fields. Many companies actively seek jobs in Europe for foreigners, appreciating the diversity and skills international graduates bring.</b><br/><br/>
    <br/><br/>
    <p>There’s also a rise in remote jobs in Europe, allowing you to work for companies in one country while living in another. This flexibility attracts skilled professionals in IT, content creation, customer service, and data analysis who want to enjoy Europe’s lifestyle without relocating multiple times.</p>
    </>
        }
      },
      {
        title: 'Visa and Immigration Benefits',
        content: {
          img: europefaq5,
          heading: 'Visa and Immigration Benefits',
          text:  <><b>Most European countries have student visa programs that allow you to stay and work abroad in Europe after graduation. Post-study work permits can last from one to two years, giving you time to secure a permanent role. In some cases, working for a certain number of years in Europe can lead to permanent residency, making it easier to settle down and build a life there.</b><br/><br/>
    <br/><br/>
    <p>If your degree is recognized across the EU, you can also benefit from the freedom of movement policy, which allows you to apply for jobs in Europe without restrictive procedures.</p>
    </>
        }
      },
     
       {
        title: 'Europe – Where Education Meets Opportunity',
        content: {
          img: europefaq6,
          heading: 'Europe – Where Education Meets Opportunity',
          text:  <>From its globally recognized universities to its thriving job markets, Europe offers a complete package for anyone looking to study and work in Europe. The ability to live, learn, and earn across multiple countries makes it one of the most flexible and rewarding destinations for students worldwide.<br/><br/>
     <p>Whether you’re aiming to gain a degree in business, engineering, medicine, arts, or any other field, you’ll find that Europe not only gives you the education you need but also the real-world experience to turn your ambitions into reality.</p>
    <br/><br/>
    <p>Choosing to study in Europe for international students means investing in your future while enjoying a culturally rich, academically advanced, and career-oriented environment. So take the leap—your European journey could be the most rewarding chapter of your life.</p>
    </>
        }
      },

       {
        title: 'Study in Europe – Endless Education and Work Opportunities Across the Continent',
        content: {
          img: europefaq7,
          heading: 'Study in Europe – Endless Education and Work Opportunities Across the Continent',
          text:  <>When it comes to studying abroad, Europe is a dream destination for millions of students. It’s a region where centuries-old universities meet cutting-edge innovation, and where studying in Europe for international students is not just about academics but also about experiencing multiple cultures, languages, and career opportunities in one vast region.
    <br/><br/>
    <br/><br/>
    </>
        }
      },
       {
        title: 'Why Study in Europe for International Students?',
        content: {
          img: europefaq8,
          heading: 'Why Study in Europe for International Students?',
          text:  <>Europe offers a unique advantage – the ability to study in one country and explore countless others. Whether you choose Germany, France, Spain, Italy, or the Netherlands, universities in Europe for international students are recognized for their academic excellence, research-driven learning, and industry links.
    <br/><br/>
     <p>When you study in Europe, you can benefit from affordable or even free tuition in certain countries, scholarships for international students, and programs taught in English. Moreover, many institutions focus on practical training, internships, and career placement, helping you transition smoothly into the professional world.</p>
    <br/><br/>
    </>
        }
      },
      {
        title: 'Top Universities in Europe',
        content: {
          img: europefaq9,
          heading: 'Top Universities in Europe',
          text:  <>From Oxford University in the UK to the University of Amsterdam, ETH Zurich, and the University of Barcelona, Europe boasts a wide range of prestigious institutions. Universities in Europe for international students are known for offering diverse programs, global faculty, and student exchange opportunities.
    <br/><br/>
    <p>By studying in Europe, you’ll gain qualifications that are recognized worldwide, making it easier to find a job in Europe or beyond after graduation.</p>
    <br/><br/>
    </>
        }
      },    
      {
        title: 'Work Anywhere in Europe',
        content: {
          img: europefaq10,
          heading: 'Work Anywhere in Europe',
          text:  <>One of the biggest benefits of completing your education here is the chance to work anywhere in Europe. Many countries allow graduates to stay and work after completing their studies. Whether you want to find a job in Europe in technology, healthcare, finance, design, or engineering, there are career paths to suit every skill set.
    <br/><br/>
    <p>Careers in Europe are abundant, and the continent is home to both multinational corporations and innovative startups. For those who wish to work abroad, Europe is an ideal place to start. Whether you’re looking for remote jobs in Europe or on-site roles, the job market is dynamic and diverse.</p>
    <br/><br/>
    </>
        }
      },    
      {
        title: 'Work Abroad and Remote Opportunities',
        content: {
          img: europefaq11,
          heading: 'Work Abroad and Remote Opportunities',
          text:  <>With the rise of digital transformation, remote jobs in Europe are becoming increasingly common. This means you could study in Europe and then work for companies across the world without leaving your chosen city. The EU’s integrated job market also allows qualified professionals to move between member countries more easily.
    <br/><br/>
    <br/><br/>
    </>
        }
      },    
      {
        title: 'Cultural Advantages',
        content: {
          img: europefaq12,
          heading: 'Cultural Advantages',
          text:  <>Studying in Europe for international students is also about personal growth. The cultural diversity, history, and lifestyle make it a truly enriching experience. You can travel across borders without the need for multiple visas, experience different cuisines, languages, and traditions, and build an international network of friends and professional contacts.
    <br/><br/>
    <p>In conclusion, choosing to study in Europe opens the door to a future filled with possibilities. From top-ranked universities in Europe for international students to the freedom to work anywhere in Europe, your journey here will be a blend of academic achievement, cultural enrichment, and career success.</p>
    <br/><br/>
    </>
        }
      },    
    ]
  },

// Source: :contentReference[oaicite:0]{index=0}

{
  id: "Dubai",
  bannersubtitle: "Study in Dubai for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Dubai with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Dubai-banner.png",

  img1: Dubaifirst,
  img2: DubaiSecond,

  heading1: "Study in Dubai for International Students",
  para1: <>Dubai is one of the fastest-growing education hubs for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Dubai</Link>. With world-class infrastructure and globally recognized institutions, students gain access to top universities in Dubai for international students offering industry-focused programs and global exposure.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Dubai for international students to understanding Dubai student visa requirements and planning your academic journey effectively.</>,

  heading2: "Top Courses in Dubai Universities & Cost of Studying in Dubai",
  para2: <>Students who choose to study in Dubai can explore a wide range of top courses in Dubai universities across fields such as business, engineering, IT, healthcare, and hospitality.<br/><br/>
  We also help you understand the cost of studying in Dubai, including tuition fees, living expenses, and financial planning, while providing complete guidance on Dubai student visa requirements for a smooth admission process.</>,

  carouseltitle: "Top Courses in Dubai Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Dubai include:",

  carousellist: [
    {
      img: Dubaicourse1,
      title: "Business & Management in Dubai",
      desc: "Top courses in Dubai universities with global career opportunities."
    },
    {
      img: Dubaicourse2,
      title: "Information Technology in Dubai",
      desc: "High-demand programs offered by universities in Dubai for international students."
    },
    {
      img: Dubaicourse3,
      title: "Engineering & Construction",
      desc: "Advanced programs with strong industry demand in Dubai."
    },
    {
      img: Dubaicourse4,
      title: "Hospitality & Tourism in Dubai",
      desc: "Leading courses aligned with Dubai’s booming tourism sector."
    }
  ],

  milestones: [

    {
      title: "Study Abroad in Dubai – Academic Excellence",
      content: {
        img: Dubaifaq1,
        heading: "Study Abroad in Dubai with Top Universities",
        text: <>
        <b>Choosing to study abroad in Dubai gives you access to globally recognized education from universities in Dubai for international students.</b><br/><br/>
        <ul>
          <li>Industry-focused programs</li>
          <li>Global exposure and networking</li>
          <li>Modern infrastructure and facilities</li>
          <li>Career-oriented learning</li>
        </ul>
        <br/>
        <p>We help you select the best universities in Dubai for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Universities in Dubai for International Students",
      content: {
        img: Dubaifaq2,
        heading: "Top Universities in Dubai for International Students",
        text: <>
        Dubai is home to globally recognized institutions offering high-quality education.<br/><br/>
        Students planning to study in Dubai can choose from top universities in Dubai for international students with strong academic and industry connections.
        </>
      }
    },

    {
      title: "Top Courses in Dubai Universities",
      content: {
        img: Dubaifaq3,
        heading: "Top Courses in Dubai Universities",
        text: <>
        Students who study abroad in Dubai can choose from a variety of top courses in Dubai universities such as:<br/><br/>
        <ul>
          <li>Business and Management</li>
          <li>Information Technology</li>
          <li>Engineering and Construction</li>
          <li>Hospitality and Tourism</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Dubai",
      content: {
        img: Dubaifaq4,
        heading: "Career Opportunities After Study in Dubai",
        text: <>
        Students graduating from universities in Dubai for international students can explore career opportunities across industries like IT, finance, aviation, healthcare, and hospitality.<br/><br/>
        Dubai’s growing economy offers excellent job prospects for international graduates.
        </>
      }
    },

    {
      title: "Work While Studying in Dubai",
      content: {
        img: Dubaifaq1,
        heading: "Work While Studying in Dubai",
        text: <>
        Students who study in Dubai can explore part-time work opportunities while studying, helping manage the cost of studying in Dubai and gaining practical experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Dubai Student Visa Requirements",
      content: {
        img: Dubaifaq2,
        heading: "Dubai Student Visa Requirements",
        text: <>
        <b>Understanding Dubai student visa requirements is essential to study abroad in Dubai.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized institution</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial stability</li>
          <li>Medical and insurance requirements</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Cost of Studying in Dubai",
      content: {
        img: Dubaifaq3,
        heading: "Cost of Studying in Dubai",
        text: <>
        The cost of studying in Dubai includes tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively so you can study in Dubai without stress.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: Dubaifaq4,
        heading: "Best Guidance to Study Abroad in Dubai",
        text: <>
        <ul>
          <li>Expert support for study abroad in Dubai</li>
          <li>Access to top universities in Dubai for international students</li>
          <li>Guidance on top courses in Dubai universities</li>
          <li>Complete Dubai student visa requirements support</li>
          <li>Support in managing cost of studying in Dubai</li>
        </ul>
        <p>Whether you want to study in Dubai, choose from top universities in Dubai for international students, or understand the cost of studying in Dubai, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

// Source: :contentReference[oaicite:0]{index=0}

{
  id: "Singapore",
  bannersubtitle: "Study in Singapore for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Singapore with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Singapore-banner.png",

  img1: Singaporefirst,
  img2: SingaporeSecond,

  heading1: "Study in Singapore for International Students",
  para1: <>Singapore is one of the top destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Singapore</Link> due to its world-class education system and strong global reputation. The country is home to leading universities in Singapore for international students offering industry-focused programs and global career exposure.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Singapore for international students to understanding Singapore student visa requirements and planning your academic journey effectively.</>,

  heading2: "Top Courses in Singapore Universities & Cost of Studying in Singapore",
  para2: <>Students who choose to study in Singapore can explore a wide range of top courses in Singapore universities across fields such as business, IT, engineering, finance, and healthcare.<br/><br/>
  We also help you understand the cost of studying in Singapore, including tuition fees, living expenses, and financial planning, while providing complete guidance on Singapore student visa requirements for a smooth admission process.</>,

  carouseltitle: "Top Courses in Singapore Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Singapore include:",

  carousellist: [
    {
      img: Singaporecourse1,
      title: "Business & Management in Singapore",
      desc: "Top courses in Singapore universities with global career opportunities."
    },
    {
      img: Singaporecourse2,
      title: "Information Technology in Singapore",
      desc: "High-demand programs offered by universities in Singapore for international students."
    },
    {
      img: Singaporecourse3,
      title: "Finance & Banking in Singapore",
      desc: "Leading programs aligned with Singapore’s global financial hub."
    },
    {
      img: Singaporecourse4,
      title: "Engineering & Technology",
      desc: "Advanced courses with strong industry demand."
    }
  ],

  milestones: [

    {
      title: "Study Abroad in Singapore – Academic Excellence",
      content: {
        img: Singaporefaq1,
        heading: "Study Abroad in Singapore with Top Universities",
        text: <>
        <b>Choosing to study abroad in Singapore gives you access to globally recognized education from universities in Singapore for international students.</b><br/><br/>
        <ul>
          <li>Industry-focused programs</li>
          <li>Global exposure and networking</li>
          <li>Modern infrastructure and research facilities</li>
          <li>Career-oriented learning</li>
        </ul>
        <br/>
        <p>We help you select the best universities in Singapore for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Universities in Singapore for International Students",
      content: {
        img: Singaporefaq2,
        heading: "Top Universities in Singapore for International Students",
        text: <>
        Singapore is home to globally ranked institutions offering high-quality education.<br/><br/>
        Students planning to study in Singapore can choose from top universities in Singapore for international students known for academic excellence and strong industry connections.
        </>
      }
    },

    {
      title: "Top Courses in Singapore Universities",
      content: {
        img: Singaporefaq3,
        heading: "Top Courses in Singapore Universities",
        text: <>
        Students who study abroad in Singapore can choose from a variety of top courses in Singapore universities such as:<br/><br/>
        <ul>
          <li>Business and Management</li>
          <li>Information Technology</li>
          <li>Finance and Banking</li>
          <li>Engineering and Technology</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Singapore",
      content: {
        img: Singaporefaq4,
        heading: "Career Opportunities After Study in Singapore",
        text: <>
        Students graduating from universities in Singapore for international students can explore career opportunities across industries like finance, IT, logistics, and healthcare.<br/><br/>
        Singapore’s strong economy offers excellent job prospects for international graduates.
        </>
      }
    },

    {
      title: "Work While Studying in Singapore",
      content: {
        img: Singaporefaq1,
        heading: "Work While Studying in Singapore",
        text: <>
        Students who study in Singapore can explore part-time work opportunities while studying, helping manage the cost of studying in Singapore and gaining practical experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Singapore Student Visa Requirements",
      content: {
        img: Singaporefaq2,
        heading: "Singapore Student Visa Requirements",
        text: <>
        <b>Understanding Singapore student visa requirements is essential to study abroad in Singapore.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized institution</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial support</li>
          <li>Medical and visa documentation</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Cost of Studying in Singapore",
      content: {
        img: Singaporefaq3,
        heading: "Cost of Studying in Singapore",
        text: <>
        The cost of studying in Singapore includes tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively so you can study in Singapore without stress.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: Singaporefaq4,
        heading: "Best Guidance to Study Abroad in Singapore",
        text: <>
        <ul>
          <li>Expert support for study abroad in Singapore</li>
          <li>Access to top universities in Singapore for international students</li>
          <li>Guidance on top courses in Singapore universities</li>
          <li>Complete Singapore student visa requirements support</li>
          <li>Support in managing cost of studying in Singapore</li>
        </ul>
        <p>Whether you want to study in Singapore, choose from top universities in Singapore for international students, or understand the cost of studying in Singapore, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

 // Source: :contentReference[oaicite:0]{index=0}

{
  id: "Switzerland",
  bannersubtitle: "Study in Switzerland for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Switzerland with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Switzerland-banner.png",

  img1: Switzerlandfirst,
  img2: SwitzerlandSecond,

  heading1: "Study in Switzerland for International Students",
  para1: <>Switzerland is one of the most prestigious destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Switzerland</Link> due to its world-class education system, innovation-driven learning, and global career opportunities. The country is home to top universities in Switzerland for international students offering internationally recognized degrees and strong industry exposure.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Switzerland for international students to understanding Switzerland student visa requirements and planning your academic journey effectively.</>,

  heading2: "Top Courses in Swiss Universities & Cost of Studying in Switzerland",
  para2: <>Students who choose to study in Switzerland can explore a wide range of top courses in Swiss universities across fields such as hospitality, business, finance, engineering, and life sciences.<br/><br/>
  We also help you understand the cost of studying in Switzerland, including tuition fees, living expenses, and financial planning, while providing complete guidance on Switzerland student visa requirements for a smooth admission process.</>,

  carouseltitle: "Top Courses in Swiss Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Switzerland include:",

  carousellist: [
    {
      img: Switzerlandcourse1,
      title: "Hospitality & Hotel Management",
      desc: "Top courses in Swiss universities with global recognition."
    },
    {
      img: Switzerlandcourse2,
      title: "Business & Finance in Switzerland",
      desc: "High-demand programs offered by universities in Switzerland for international students."
    },
    {
      img: Switzerlandcourse3,
      title: "Engineering & Technology",
      desc: "Advanced programs with strong global career prospects."
    },
    {
      img: Switzerlandcourse4,
      title: "Life Sciences & Healthcare",
      desc: "Leading courses in Swiss universities with research-driven learning."
    }
  ],

  milestones: [

    {
      title: "Study Abroad in Switzerland – Academic Excellence",
      content: {
        img: Switzerlandfaq1,
        heading: "Study Abroad in Switzerland with Top Universities",
        text: <>
        <b>Choosing to study abroad in Switzerland gives you access to globally recognized education from universities in Switzerland for international students.</b><br/><br/>
        <ul>
          <li>Research-driven academic programs</li>
          <li>Industry-focused learning</li>
          <li>Global exposure and networking</li>
          <li>High-quality education standards</li>
        </ul>
        <br/>
        <p>We help you select the best universities in Switzerland for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Universities in Switzerland for International Students",
      content: {
        img: Switzerlandfaq2,
        heading: "Top Universities in Switzerland for International Students",
        text: <>
        Switzerland is home to globally ranked institutions offering high-quality education.<br/><br/>
        Students planning to study in Switzerland can choose from top universities in Switzerland for international students known for academic excellence and global recognition.
        </>
      }
    },

    {
      title: "Top Courses in Swiss Universities",
      content: {
        img: Switzerlandfaq3,
        heading: "Top Courses in Swiss Universities",
        text: <>
        Students who study abroad in Switzerland can choose from a variety of top courses in Swiss universities such as:<br/><br/>
        <ul>
          <li>Hospitality and Hotel Management</li>
          <li>Business and Finance</li>
          <li>Engineering and Technology</li>
          <li>Life Sciences and Healthcare</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Switzerland",
      content: {
        img: Switzerlandfaq4,
        heading: "Career Opportunities After Study in Switzerland",
        text: <>
        Students graduating from universities in Switzerland for international students can explore career opportunities across industries like finance, hospitality, pharmaceuticals, and engineering.<br/><br/>
        Switzerland offers strong job prospects and international career exposure.
        </>
      }
    },

    {
      title: "Work While Studying in Switzerland",
      content: {
        img: Switzerlandfaq1,
        heading: "Work While Studying in Switzerland",
        text: <>
        Students who study in Switzerland can explore part-time work opportunities while studying, helping manage the cost of studying in Switzerland and gaining practical experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Switzerland Student Visa Requirements",
      content: {
        img: Switzerlandfaq2,
        heading: "Switzerland Student Visa Requirements",
        text: <>
        <b>Understanding Switzerland student visa requirements is essential to study abroad in Switzerland.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized institution</li>
          <li>Proof of financial stability</li>
          <li>Valid passport and documents</li>
          <li>Health insurance requirements</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Cost of Studying in Switzerland",
      content: {
        img: Switzerlandfaq3,
        heading: "Cost of Studying in Switzerland",
        text: <>
        The cost of studying in Switzerland includes tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively so you can study in Switzerland without stress.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: Switzerlandfaq4,
        heading: "Best Guidance to Study Abroad in Switzerland",
        text: <>
        <ul>
          <li>Expert support for study abroad in Switzerland</li>
          <li>Access to top universities in Switzerland for international students</li>
          <li>Guidance on top courses in Swiss universities</li>
          <li>Complete Switzerland student visa requirements support</li>
          <li>Support in managing cost of studying in Switzerland</li>
        </ul>
        <p>Whether you want to study in Switzerland, choose from top universities in Switzerland for international students, or understand the cost of studying in Switzerland, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},
  {
  id: "Netherlands",
  bannersubtitle: "Study in the Netherlands",
  bannertitleone: "Study in the Netherlands: Innovation, ",
  bannertitletwo: "Research, and Global Opportunities",
  bannerbgimg: "/images/Netherlands-banner.png",
  img1: NetherlandsFirst,
  img2: NetherlandsSecond,
  heading1: "Achieve Academic and Professional Excellence in the Netherlands with Nova EduBridge",
  para1: <>The Netherlands is known for its progressive education system, cutting-edge research, and vibrant international environment. Dutch universities 
  consistently rank among the top in Europe, offering English-taught programs across a wide range of disciplines. As a 
  hub for innovation and entrepreneurship, the Netherlands is home to thriving industries including technology, 
  logistics, agriculture, finance, and creative sectors. Its strategic location in Europe provides students and 
  professionals with global networking and career opportunities. Nova EduBridge helps you turn your dream of studying and working in the Netherlands into reality.</>,
  heading2: "Why Choose the Netherlands?",
  para2: <>The Netherlands combines world-class education, diverse career prospects, and a high quality of life. Its universities emphasize research-driven learning, innovation, and collaboration with industries. With a strong economy and the presence of global companies such as Philips, ING, ASML, and Unilever, the Netherlands offers excellent job opportunities in various sectors. Beyond academics and work, the Netherlands is known for its safety, multicultural environment, efficient transport, and high living standards. Choosing the Netherlands means investing in a bright academic and professional future.</>,
  carouseltitle: "Opportunities Await in the Netherlands",
  carouselsubtitle: "Where innovation meets world-class education and careers.",
  carousellist: [
    { img: NetherlandsCourse1, title: "Innovative Learning Environment", desc: "Study in universities that promote creativity, critical thinking, and real-world application of knowledge." },
    { img: NetherlandsCourse2, title: "Hub for Technology and Design", desc: "The Netherlands leads in high-tech industries, engineering, and creative sectors with global recognition." },
    { img: NetherlandsCourse3, title: "Gateway to European Careers", desc: "Its strategic location and international companies make it a career hotspot for global professionals." },
    { img: NetherlandsCourse4, title: "Student-Friendly Lifestyle", desc: "Safe cities, excellent infrastructure, and vibrant culture create an ideal environment for growth." }
  ],
  milestones: [
    {
      title: "Academic Excellence in the Netherlands",
      content: {
        img: NetherlandsFaq1,
        heading: "The Netherlands – A Pioneer in Education",
        text: <>Dutch universities emphasize innovation, problem-solving, and collaboration. Students benefit from strong ties to industries, internship opportunities, and research-driven programs preparing them for global careers.<br/><br/>
        <p>Nova EduBridge assists with admissions, scholarships, housing, and pre-departure support to ensure a seamless journey.</p></>
      }
    },
    {
      title: "Jobs in the Netherlands",
      content: {
        img: NetherlandsFaq2,
        heading: "The Netherlands – Career Gateway to Europe",
        text: <>With a robust economy and global connectivity, the Netherlands offers careers in diverse fields like high-tech, finance, agriculture, logistics, and creative industries. It is home to multinational giants like Philips, ASML, Heineken, and Unilever.<br/><br/>
        <p>Nova EduBridge partners with top employers to help you land internships and jobs that align with your skills and goals.</p></>
      }
    },
    {
      title: "Long-Term Careers in the Netherlands",
      content: {
        img: NetherlandsFaq3,
        heading: "Building Your Future in the Netherlands",
        text: <>The Netherlands is an ideal place to build a sustainable career, thanks to its stable economy, global outlook, and strong work-life balance. Many international professionals choose to stay long-term due to its welcoming environment and growth prospects.<br/><br/>
        Nova EduBridge provides ongoing support for career advancement, skill upgrades, and settlement options.</>
      }
    },
    {
      title: "Visa Guidance",
      content: {
        img: NetherlandsFaq4,
        heading: "Visa and Residency Made Simple",
        text: <>Navigating the Dutch visa and residency process can seem challenging, but Nova EduBridge makes it easy. From student visas to work permits and residence cards, we ensure complete documentation and timely application.<br/><br/>
        Focus on your education and career while we handle the formalities of your move to the Netherlands.</>
      }
    }
  ]
  },


{
  id: "Italy",
  bannersubtitle: "Study in Italy for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Italy with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Italy-banner.png",

  img1: ItalyFirst,
  img2: ItalySecond,

  heading1: "Study in Italy for International Students",
  para1: <>Italy is one of the most attractive destinations for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Italy</Link> for international students due to its rich academic heritage, innovative learning environment, and global career opportunities. The country is home to top universities in Italy for international students offering globally recognized degrees across various disciplines.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Italy for international students to understanding Italy student visa requirements and process and planning your academic journey effectively.</>,

  heading2: "Top Courses to Study in Italy & Cost of Studying in Italy for International Students",
  para2: <>Students who choose to study in Italy can explore a wide range of top courses to study in Italy including fashion, design, architecture, engineering, business, and hospitality.<br/><br/>
  We also help you understand the cost of studying in Italy for international students, including tuition fees, living expenses, and financial planning, while providing complete guidance on Italy student visa requirements and process.</>,

  carouseltitle: "Top Courses to Study in Italy",
  carouselsubtitle: "Popular options for students planning to study abroad in Italy for international students include:",

  carousellist: [
    {
      img: ItalyCourse1,
      title: "Fashion & Design in Italy",
      desc: "Top courses to study in Italy with global recognition."
    },
    {
      img: ItalyCourse2,
      title: "Architecture & Engineering",
      desc: "Advanced programs offered by universities in Italy for international students."
    },
    {
      img: ItalyCourse3,
      title: "Business & Management",
      desc: "Leading programs with strong career opportunities."
    },
    {
      img: ItalyCourse4,
      title: "Hospitality & Tourism",
      desc: "Industry-focused courses aligned with Italy’s tourism sector."
    }
  ],

  milestones: [

    {
      title: "Study Abroad in Italy – Academic Excellence",
      content: {
        img: ItalyFaq1,
        heading: "Study Abroad in Italy for International Students",
        text: <>
        <b>Choosing to study abroad in Italy for international students gives you access to globally recognized education from universities in Italy for international students.</b><br/><br/>
        <ul>
          <li>Creative and research-driven learning</li>
          <li>Global exposure and networking</li>
          <li>Industry-focused academic programs</li>
          <li>Affordable education opportunities</li>
        </ul>
        <br/>
        <p>We help you select the best universities in Italy for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Universities in Italy for International Students",
      content: {
        img: ItalyFaq2,
        heading: "Top Universities in Italy for International Students",
        text: <>
        Italy is home to some of the oldest and most prestigious institutions in the world.<br/><br/>
        Students planning to study in Italy can choose from top universities in Italy for international students known for academic excellence and global recognition.
        </>
      }
    },

    {
      title: "Top Courses to Study in Italy",
      content: {
        img: ItalyFaq3,
        heading: "Top Courses to Study in Italy",
        text: <>
        Students who study abroad in Italy for international students can choose from a variety of top courses to study in Italy such as:<br/><br/>
        <ul>
          <li>Fashion and Design</li>
          <li>Architecture and Engineering</li>
          <li>Business and Management</li>
          <li>Hospitality and Tourism</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Italy",
      content: {
        img: ItalyFaq4,
        heading: "Career Opportunities After Study in Italy",
        text: <>
        Students graduating from universities in Italy for international students can explore career opportunities across industries like fashion, automotive, engineering, and tourism.<br/><br/>
        Italy offers strong career prospects and access to the European job market.
        </>
      }
    },

    {
      title: "Work While Studying in Italy",
      content: {
        img: ItalyFaq1,
        heading: "Work While Studying in Italy",
        text: <>
        Students who study in Italy can explore part-time work opportunities while studying, helping manage the cost of studying in Italy for international students and gaining practical experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Italy Student Visa Requirements and Process",
      content: {
        img: ItalyFaq2,
        heading: "Italy Student Visa Requirements and Process",
        text: <>
        <b>Understanding Italy student visa requirements and process is essential to study abroad in Italy for international students.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Proof of financial stability</li>
          <li>Valid passport and documentation</li>
          <li>Health insurance requirements</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Cost of Studying in Italy for International Students",
      content: {
        img: ItalyFaq3,
        heading: "Cost of Studying in Italy for International Students",
        text: <>
        The cost of studying in Italy for international students includes tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively so you can study in Italy without stress.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: ItalyFaq4,
        heading: "Best Guidance to Study Abroad in Italy",
        text: <>
        <ul>
          <li>Expert support for study abroad in Italy for international students</li>
          <li>Access to top universities in Italy for international students</li>
          <li>Guidance on top courses to study in Italy</li>
          <li>Complete Italy student visa requirements and process support</li>
          <li>Support in managing cost of studying in Italy for international students</li>
        </ul>
        <p>Whether you want to study in Italy, choose from top universities in Italy for international students, or understand the cost of studying in Italy for international students, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

{
  id: "Poland",
  bannersubtitle: "Study in Poland for Global Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study in Poland with Affordable Education and",
  bannertitletwo: "Top Universities & Visa Guidance",

  bannerbgimg: "/images/Poland-banner.png",

  img1: PolandFirst,
  img2: PolandSecond,

  heading1: "Study in Poland for International Students",
  para1: <>Poland has become a top destination for students looking for affordable education in Poland for international students with 
  globally recognized degrees and strong career opportunities. The country is home to leading <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>universities in Poland for international students</Link> offering high-quality programs across engineering, medicine, business, and IT.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Poland for international students to understanding Poland 
  student visa requirements and process and planning your academic journey effectively.</>,

  heading2: "Top Courses in Polish Universities & Affordable Education in Poland",
  para2: <>Students who choose to study in Poland can explore a wide range of top courses in Polish universities including engineering, IT, business, and healthcare. Many students also choose to study MBBS in Poland for international students due to its high-quality medical education and affordability.<br/><br/>
  We also help you understand affordable education in Poland for international students, including tuition fees and living costs, while providing complete support for Poland student visa requirements and process.</>,

  carouseltitle: "Top Courses in Polish Universities",
  carouselsubtitle: "Popular options for students planning to study in Poland include:",

  carousellist: [
    {
      img: PolandCourse1,
      title: "Engineering & Technology in Poland",
      desc: "Top courses in Polish universities with strong industry demand."
    },
    {
      img: PolandCourse2,
      title: "MBBS in Poland for International Students",
      desc: "High-quality medical education at affordable cost."
    },
    {
      img: PolandCourse3,
      title: "Business & Management",
      desc: "Leading programs offered by universities in Poland for international students."
    },
    {
      img: PolandCourse4,
      title: "Information Technology",
      desc: "In-demand courses with strong career opportunities."
    }
  ],

  milestones: [

    {
      title: "Universities in Poland for International Students",
      content: {
        img: PolandFaq1,
        heading: "Top Universities in Poland for International Students",
        text: <>
        <b>Poland offers access to globally recognized universities in Poland for international students known for academic excellence and innovation.</b><br/><br/>
        <ul>
          <li>Industry-focused programs</li>
          <li>Modern research facilities</li>
          <li>International exposure</li>
          <li>Strong academic reputation</li>
        </ul>
        <br/>
        <p>We help you choose the best universities in Poland for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Top Courses in Polish Universities",
      content: {
        img: PolandFaq2,
        heading: "Top Courses in Polish Universities",
        text: <>
        Students can choose from a variety of top courses in Polish universities such as:<br/><br/>
        <ul>
          <li>Engineering and Technology</li>
          <li>Business and Management</li>
          <li>Information Technology</li>
          <li>Study MBBS in Poland for international students</li>
        </ul>
        </>
      }
    },

    {
      title: "Benefits of Studying in Poland for Foreign Students",
      content: {
        img: PolandFaq3,
        heading: "Benefits of Studying in Poland for Foreign Students",
        text: <>
        <b>There are several benefits of studying in Poland for foreign students including:</b><br/><br/>
        <ul>
          <li>Affordable education in Poland for international students</li>
          <li>High-quality academic programs</li>
          <li>Opportunities to work while studying</li>
          <li>Access to the European job market</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Poland",
      content: {
        img: PolandFaq4,
        heading: "Career Opportunities After Study in Poland",
        text: <>
        Students graduating from universities in Poland for international students can explore career opportunities across IT, engineering, finance, and manufacturing.<br/><br/>
        Poland’s growing economy offers strong job prospects for international graduates.
        </>
      }
    },

    {
      title: "Work While Studying in Poland",
      content: {
        img: PolandFaq1,
        heading: "Work While Studying in Poland",
        text: <>
        Students who study in Poland can take up part-time work opportunities to support their living expenses and gain experience.<br/><br/>
        This enhances employability after graduation.
        </>
      }
    },

    {
      title: "Poland Student Visa Requirements and Process",
      content: {
        img: PolandFaq2,
        heading: "Poland Student Visa Requirements and Process",
        text: <>
        <b>Understanding Poland student visa requirements and process is essential for studying in Poland.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Proof of financial stability</li>
          <li>Valid passport and documentation</li>
          <li>Health insurance</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa process.</p>
        </>
      }
    },

    {
      title: "Affordable Education in Poland for International Students",
      content: {
        img: PolandFaq3,
        heading: "Cost of Studying in Poland for International Students",
        text: <>
        Poland is known for offering affordable education in Poland for international students with low tuition fees and reasonable living costs.<br/><br/>
        We help you plan your finances effectively to make your study journey stress-free.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: PolandFaq4,
        heading: "Best Guidance to Study in Poland",
        text: <>
        <ul>
          <li>Expert support for universities in Poland for international students</li>
          <li>Guidance on top courses in Polish universities</li>
          <li>Support for study MBBS in Poland for international students</li>
          <li>Complete Poland student visa requirements and process support</li>
          <li>Assistance with affordable education planning</li>
        </ul>
        <p>Whether you want to study in Poland, explore universities in Poland for international students, or benefit from affordable education in Poland for international students, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

{
  id: "Georgia",
  bannersubtitle: "Study in Georgia for Affordable Global Education",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Georgia with Affordable Education and",
  bannertitletwo: "Top Universities & Visa Guidance",

  bannerbgimg: "/images/Georgia-banner.png",

  img1: GeorgiaFirst,
  img2: GeorgiaSecond,

  heading1: "Study in Georgia for International Students",
  para1: <>Georgia is becoming a popular destination for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Georgia</Link> for international students due to its affordable education system and globally recognized degrees. The country is home to leading universities in Georgia for international students offering high-quality programs in medicine, engineering, business, and IT.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Georgia for international students to understanding Georgia student visa requirements and process and planning your academic journey effectively.</>,

  heading2: "Top Courses in Georgian Universities & Cost of Studying in Georgia",
  para2: <>Students who choose to study in Georgia can explore a wide range of top courses in Georgian universities including MBBS, engineering, IT, business, and healthcare.<br/><br/>
  We also help you understand the cost of studying in Georgia for international students, including tuition fees and living expenses, while providing complete support for Georgia student visa requirements and process.</>,

  carouseltitle: "Top Courses in Georgian Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Georgia for international students include:",

  carousellist: [
    {
      img: GeorgiaCourse1,
      title: "MBBS in Georgia",
      desc: "Top courses in Georgian universities with affordable fees and global recognition."
    },
    {
      img: GeorgiaCourse2,
      title: "Engineering & Technology",
      desc: "High-demand programs offered by universities in Georgia for international students."
    },
    {
      img: GeorgiaCourse3,
      title: "Business & Management",
      desc: "Industry-focused programs with strong career opportunities."
    },
    {
      img: GeorgiaCourse4,
      title: "Information Technology",
      desc: "In-demand courses aligned with global industry needs."
    }
  ],

  milestones: [

    {
      title: "Study Abroad in Georgia – Academic Excellence",
      content: {
        img: GeorgiaFaq1,
        heading: "Study Abroad in Georgia for International Students",
        text: <>
        <b>Choosing to study abroad in Georgia for international students gives you access to globally recognized education from universities in Georgia for international students.</b><br/><br/>
        <ul>
          <li>Affordable education in Georgia for international students</li>
          <li>Industry-focused programs</li>
          <li>Global exposure and networking</li>
          <li>Modern infrastructure and facilities</li>
        </ul>
        <br/>
        <p>We help you choose the best universities in Georgia for international students based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Universities in Georgia for International Students",
      content: {
        img: GeorgiaFaq2,
        heading: "Top Universities in Georgia for International Students",
        text: <>
        Georgia offers access to recognized institutions providing quality education.<br/><br/>
        Students planning to study in Georgia can choose from top universities in Georgia for international students known for affordability and academic excellence.
        </>
      }
    },

    {
      title: "Top Courses in Georgian Universities",
      content: {
        img: GeorgiaFaq3,
        heading: "Top Courses in Georgian Universities",
        text: <>
        Students who study abroad in Georgia for international students can choose from a variety of top courses in Georgian universities such as:<br/><br/>
        <ul>
          <li>MBBS and Healthcare Programs</li>
          <li>Engineering and Technology</li>
          <li>Business and Management</li>
          <li>Information Technology</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Georgia",
      content: {
        img: GeorgiaFaq4,
        heading: "Career Opportunities After Study in Georgia",
        text: <>
        Students graduating from universities in Georgia for international students can explore career opportunities in healthcare, IT, tourism, and business sectors.<br/><br/>
        Georgia’s growing economy offers emerging job opportunities for international graduates.
        </>
      }
    },

    {
      title: "Work While Studying in Georgia",
      content: {
        img: GeorgiaFaq1,
        heading: "Work While Studying in Georgia",
        text: <>
        Students who study in Georgia can explore part-time work opportunities to support the cost of studying in Georgia for international students and gain experience.<br/><br/>
        This enhances employability after graduation.
        </>
      }
    },

    {
      title: "Georgia Student Visa Requirements and Process",
      content: {
        img: GeorgiaFaq2,
        heading: "Georgia Student Visa Requirements and Process",
        text: <>
        <b>Understanding Georgia student visa requirements and process is essential to study abroad in Georgia for international students.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial stability</li>
          <li>Health insurance requirements</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa process.</p>
        </>
      }
    },

    {
      title: "Cost of Studying in Georgia for International Students",
      content: {
        img: GeorgiaFaq3,
        heading: "Cost of Studying in Georgia for International Students",
        text: <>
        The cost of studying in Georgia for international students is highly affordable compared to other countries, covering tuition fees, accommodation, and living expenses.<br/><br/>
        We help you plan your finances effectively for a stress-free experience.
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: GeorgiaFaq4,
        heading: "Best Guidance to Study Abroad in Georgia",
        text: <>
        <ul>
          <li>Expert support for study abroad in Georgia for international students</li>
          <li>Access to top universities in Georgia for international students</li>
          <li>Guidance on top courses in Georgian universities</li>
          <li>Complete Georgia student visa requirements and process support</li>
          <li>Support in managing cost of studying in Georgia for international students</li>
        </ul>
        <p>Whether you want to study in Georgia, choose from universities in Georgia for international students, or understand the cost of studying in Georgia for international students, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

{
  id: "Russia",
  bannersubtitle: "Study in Russia for Affordable Global Education",

  // ✅ Single meaningful heading
  bannertitleone: "Study in Russia with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Russia-banner.png",

  img1: RussiaFirst,
  img2: RussiaSecond,

  heading1: "Study in Russia for International Students",
  para1: <>Russia is one of the top destinations for students seeking affordable education in Russia for international students with globally recognized degrees and strong 
  academic foundations. The country is home to leading <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>Russian universities for international students</Link> offering high-quality programs in medicine, engineering, IT, and business.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting top universities in Russia for international students to understanding the Russia student visa process and requirements and planning your academic journey effectively.</>,

  heading2: "Best Courses to Study in Russia & Affordable Education in Russia",
  para2: <>Students who choose to study in Russia can explore a wide range of best courses to study in Russia for international students including medicine, engineering, IT, aerospace, and business programs. Many students also choose to study MBBS in Russia for Indian students due to its affordability and global recognition.<br/><br/>
  We also help you understand affordable education in Russia for international students, including tuition fees and living expenses, while providing complete guidance on the Russia student visa process and requirements.</>,

  carouseltitle: "Best Courses to Study in Russia",
  carouselsubtitle: "Popular options for students planning to study in Russia include:",

  carousellist: [
    {
      img: RussiaCourse1,
      title: "MBBS in Russia for Indian Students",
      desc: "Top medical programs with global recognition and affordable fees."
    },
    {
      img: RussiaCourse2,
      title: "Engineering & Technology",
      desc: "Best courses to study in Russia for international students with strong demand."
    },
    {
      img: RussiaCourse3,
      title: "Information Technology",
      desc: "In-demand programs offered by top universities in Russia for international students."
    },
    {
      img: RussiaCourse4,
      title: "Business & Management",
      desc: "Industry-focused programs with global career opportunities."
    }
  ],

  milestones: [

    {
      title: "Russian Universities for International Students",
      content: {
        img: RussiaFaq1,
        heading: "Top Universities in Russia for International Students",
        text: <>
        <b>Russia offers access to globally recognized Russian universities for international students known for academic excellence and research.</b><br/><br/>
        <ul>
          <li>Strong academic foundation</li>
          <li>Advanced research facilities</li>
          <li>Global recognition of degrees</li>
          <li>Wide range of programs</li>
        </ul>
        <br/>
        <p>We help you choose from top universities in Russia for international students based on your career goals.</p>
        </>
      }
    },

    {
      title: "Best Courses to Study in Russia",
      content: {
        img: RussiaFaq2,
        heading: "Best Courses to Study in Russia for International Students",
        text: <>
        Students can choose from a variety of best courses to study in Russia for international students such as:<br/><br/>
        <ul>
          <li>Study MBBS in Russia for Indian students</li>
          <li>Engineering and Technology</li>
          <li>Information Technology</li>
          <li>Business and Management</li>
        </ul>
        </>
      }
    },

    {
      title: "Affordable Education in Russia for International Students",
      content: {
        img: RussiaFaq3,
        heading: "Affordable Education in Russia for International Students",
        text: <>
        <b>Russia is known for providing affordable education in Russia for international students without compromising quality.</b><br/><br/>
        <ul>
          <li>Low tuition fees</li>
          <li>Affordable living costs</li>
          <li>Scholarship opportunities</li>
          <li>Value-for-money education</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Russia",
      content: {
        img: RussiaFaq4,
        heading: "Career Opportunities After Study in Russia",
        text: <>
        Students graduating from top universities in Russia for international students can explore career opportunities in sectors like energy, IT, aerospace, healthcare, and finance.<br/><br/>
        Russia’s growing industries offer strong career prospects.
        </>
      }
    },

    {
      title: "Work While Studying in Russia",
      content: {
        img: RussiaFaq1,
        heading: "Work While Studying in Russia",
        text: <>
        Students who study in Russia can explore part-time work opportunities to support their expenses and gain experience.<br/><br/>
        This enhances employability after graduation.
        </>
      }
    },

    {
      title: "Russia Student Visa Process and Requirements",
      content: {
        img: RussiaFaq2,
        heading: "Russia Student Visa Process and Requirements",
        text: <>
        <b>Understanding the Russia student visa process and requirements is essential to study in Russia.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial support</li>
          <li>Medical and visa documentation</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: RussiaFaq3,
        heading: "Best Guidance to Study in Russia",
        text: <>
        <ul>
          <li>Expert support for Russian universities for international students</li>
          <li>Guidance on best courses to study in Russia for international students</li>
          <li>Support for study MBBS in Russia for Indian students</li>
          <li>Complete Russia student visa process and requirements support</li>
          <li>Assistance with affordable education planning</li>
        </ul>
        <p>Whether you want to study in Russia, choose from top universities in Russia for international students, or benefit from affordable education in Russia for international students, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},
{
  id: "Kyrgyzstan",
  bannersubtitle: "Study in Kyrgyzstan for Affordable Global Education",

  // ✅ Single meaningful heading
  bannertitleone: "Study in Kyrgyzstan with Affordable Education and",
  bannertitletwo: "Top Universities & Visa Guidance",

  bannerbgimg: "/images/Kyrgyzstan-banner.png",

  img1: KyrgyzstanFirst,
  img2: KyrgyzstanSecond,

  heading1: "Study in Kyrgyzstan for International Students",
  para1: <>Kyrgyzstan is becoming a preferred destination for students seeking affordable education in Kyrgyzstan for foreigners with globally recognized degrees and quality academic programs. The country is home to top universities in Kyrgyzstan for international students offering strong programs in medicine, engineering, business, and IT.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting top universities in Kyrgyzstan for international students to understanding Kyrgyzstan student visa process and requirements and planning your academic journey effectively.</>,

  heading2: "Best Courses to Study in Kyrgyzstan & Affordable Education Options",
  para2: <>Students who choose to study in Kyrgyzstan can explore a wide range of best courses to study in Kyrgyzstan for international students including MBBS, engineering, IT, and business programs. Many students prefer to study MBBS in Kyrgyzstan for Indian students due to its affordability and global recognition.<br/><br/>
  We also help you understand affordable education in Kyrgyzstan for foreigners, including tuition fees and living costs, while providing complete guidance on Kyrgyzstan student visa process and requirements.</>,

  carouseltitle: "Best Courses to Study in Kyrgyzstan",
  carouselsubtitle: "Popular options for students planning to study in Kyrgyzstan include:",

  carousellist: [
    {
      img: KyrgyzstanCourse1,
      title: "MBBS in Kyrgyzstan for Indian Students",
      desc: "Affordable medical programs with global recognition."
    },
    {
      img: KyrgyzstanCourse2,
      title: "Engineering & Technology",
      desc: "Top courses offered by universities in Kyrgyzstan for international students."
    },
    {
      img: KyrgyzstanCourse3,
      title: "Business & Management",
      desc: "Industry-focused programs with strong career potential."
    },
    {
      img: KyrgyzstanCourse4,
      title: "Information Technology",
      desc: "High-demand courses aligned with global industry needs."
    }
  ],

  milestones: [

    {
      title: "Top Universities in Kyrgyzstan for International Students",
      content: {
        img: KyrgyzstanFaq1,
        heading: "Top Universities in Kyrgyzstan for International Students",
        text: <>
        <b>Kyrgyzstan offers access to recognized institutions providing quality education at affordable costs.</b><br/><br/>
        <ul>
          <li>Globally recognized degrees</li>
          <li>Affordable education in Kyrgyzstan for foreigners</li>
          <li>Modern teaching methods</li>
          <li>International student-friendly environment</li>
        </ul>
        <br/>
        <p>We help you choose the best universities based on your academic goals.</p>
        </>
      }
    },

    {
      title: "Best Courses to Study in Kyrgyzstan",
      content: {
        img: KyrgyzstanFaq2,
        heading: "Best Courses to Study in Kyrgyzstan for International Students",
        text: <>
        Students can choose from a variety of best courses to study in Kyrgyzstan for international students such as:<br/><br/>
        <ul>
          <li>Study MBBS in Kyrgyzstan for Indian students</li>
          <li>Engineering and Technology</li>
          <li>Information Technology</li>
          <li>Business and Management</li>
        </ul>
        </>
      }
    },

    {
      title: "Affordable Education in Kyrgyzstan for Foreigners",
      content: {
        img: KyrgyzstanFaq3,
        heading: "Affordable Education in Kyrgyzstan for Foreigners",
        text: <>
        <b>Kyrgyzstan is known for offering affordable education in Kyrgyzstan for foreigners without compromising on quality.</b><br/><br/>
        <ul>
          <li>Low tuition fees</li>
          <li>Affordable living costs</li>
          <li>Value-for-money education</li>
          <li>Accessible programs for international students</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Kyrgyzstan",
      content: {
        img: KyrgyzstanFaq4,
        heading: "Career Opportunities After Study in Kyrgyzstan",
        text: <>
        Students graduating from top universities in Kyrgyzstan for international students can explore career opportunities in healthcare, IT, tourism, and business sectors.<br/><br/>
        Kyrgyzstan offers emerging opportunities and international exposure.
        </>
      }
    },

    {
      title: "Work While Studying in Kyrgyzstan",
      content: {
        img: KyrgyzstanFaq1,
        heading: "Work While Studying in Kyrgyzstan",
        text: <>
        Students who study in Kyrgyzstan can explore part-time work opportunities to support their expenses and gain experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Kyrgyzstan Student Visa Process and Requirements",
      content: {
        img: KyrgyzstanFaq2,
        heading: "Kyrgyzstan Student Visa Process and Requirements",
        text: <>
        <b>Understanding Kyrgyzstan student visa process and requirements is essential to study in Kyrgyzstan.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial support</li>
          <li>Medical and visa documentation</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: KyrgyzstanFaq3,
        heading: "Best Guidance to Study in Kyrgyzstan",
        text: <>
        <ul>
          <li>Expert support for top universities in Kyrgyzstan for international students</li>
          <li>Guidance on best courses to study in Kyrgyzstan for international students</li>
          <li>Support for study MBBS in Kyrgyzstan for Indian students</li>
          <li>Complete Kyrgyzstan student visa process and requirements support</li>
          <li>Assistance with affordable education planning</li>
        </ul>
        <p>Whether you want to study in Kyrgyzstan, explore top universities in Kyrgyzstan for international students, or benefit from affordable education in Kyrgyzstan for foreigners, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},

{
  id: "Uzbekistan",
  bannersubtitle: "Study in Uzbekistan for Affordable Global Education",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Uzbekistan with Top Universities and",
  bannertitletwo: "Affordable Education & Visa Guidance",

  bannerbgimg: "/images/Uzbekistan-banner.png",

  img1: UzbekistanFirst,
  img2: UzbekistanSecond,

  heading1: "Study in Uzbekistan for International Students",
  para1: <>Uzbekistan is becoming a preferred destination for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Uzbekistan</Link> due to its affordable education system and growing global recognition. The country is home to leading universities in Uzbekistan for international students offering quality programs in medicine, engineering, IT, and business.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Uzbekistan for international students to understanding Uzbekistan student visa requirements and planning your academic journey effectively.</>,

  heading2: "Top Courses in Uzbekistan Universities & Cost of Studying in Uzbekistan",
  para2: <>Students who choose to study in Uzbekistan can explore a wide range of top courses in Uzbekistan universities including MBBS, engineering, IT, business, and healthcare programs.<br/><br/>
  We also help you understand the cost of studying in Uzbekistan, including tuition fees and living expenses, while providing complete guidance on Uzbekistan student visa requirements.</>,

  carouseltitle: "Top Courses in Uzbekistan Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Uzbekistan include:",

  carousellist: [
    {
      img: UzbekistanCourse1,
      title: "MBBS in Uzbekistan",
      desc: "Top medical programs with global recognition and affordable fees."
    },
    {
      img: UzbekistanCourse2,
      title: "Engineering & Technology",
      desc: "High-demand programs offered by universities in Uzbekistan for international students."
    },
    {
      img: UzbekistanCourse3,
      title: "Business & Management",
      desc: "Industry-focused programs with strong career opportunities."
    },
    {
      img: UzbekistanCourse4,
      title: "Information Technology",
      desc: "In-demand courses aligned with global industry needs."
    }
  ],

  milestones: [

    {
      title: "Universities in Uzbekistan for International Students",
      content: {
        img: UzbekistanFaq1,
        heading: "Top Universities in Uzbekistan for International Students",
        text: <>
        <b>Uzbekistan offers access to recognized universities in Uzbekistan for international students with growing global reputation.</b><br/><br/>
        <ul>
          <li>Affordable education opportunities</li>
          <li>Modern teaching methods</li>
          <li>English-medium programs</li>
          <li>Student-friendly environment</li>
        </ul>
        <br/>
        <p>We help you choose the best universities based on your academic and career goals.</p>
        </>
      }
    },

    {
      title: "Top Courses in Uzbekistan Universities",
      content: {
        img: UzbekistanFaq2,
        heading: "Top Courses in Uzbekistan Universities",
        text: <>
        Students can choose from a variety of top courses in Uzbekistan universities such as:<br/><br/>
        <ul>
          <li>MBBS and Healthcare Programs</li>
          <li>Engineering and Technology</li>
          <li>Information Technology</li>
          <li>Business and Management</li>
        </ul>
        </>
      }
    },

    {
      title: "Cost of Studying in Uzbekistan",
      content: {
        img: UzbekistanFaq3,
        heading: "Cost of Studying in Uzbekistan",
        text: <>
        <b>The cost of studying in Uzbekistan is highly affordable compared to many other countries.</b><br/><br/>
        <ul>
          <li>Low tuition fees</li>
          <li>Affordable accommodation</li>
          <li>Low living expenses</li>
          <li>Value-for-money education</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Uzbekistan",
      content: {
        img: UzbekistanFaq4,
        heading: "Career Opportunities After Study in Uzbekistan",
        text: <>
        Students graduating from universities in Uzbekistan for international students can explore opportunities in healthcare, IT, engineering, and business sectors.<br/><br/>
        Uzbekistan’s growing economy offers emerging career prospects.
        </>
      }
    },

    {
      title: "Work While Studying in Uzbekistan",
      content: {
        img: UzbekistanFaq1,
        heading: "Work While Studying in Uzbekistan",
        text: <>
        Students who study in Uzbekistan can explore part-time work opportunities to support the cost of studying in Uzbekistan and gain practical experience.<br/><br/>
        This improves employability after graduation.
        </>
      }
    },

    {
      title: "Uzbekistan Student Visa Requirements",
      content: {
        img: UzbekistanFaq2,
        heading: "Uzbekistan Student Visa Requirements",
        text: <>
        <b>Understanding Uzbekistan student visa requirements is essential to study abroad in Uzbekistan.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized university</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial support</li>
          <li>Medical and visa documentation</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: UzbekistanFaq3,
        heading: "Best Guidance to Study Abroad in Uzbekistan",
        text: <>
        <ul>
          <li>Expert support for study abroad in Uzbekistan</li>
          <li>Access to universities in Uzbekistan for international students</li>
          <li>Guidance on top courses in Uzbekistan universities</li>
          <li>Complete Uzbekistan student visa requirements support</li>
          <li>Support in managing cost of studying in Uzbekistan</li>
        </ul>
        <p>Whether you want to study in Uzbekistan, explore universities in Uzbekistan for international students, or understand the cost of studying in Uzbekistan, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},


{
  id: "Afghanistan",
  bannersubtitle: "Study in Afghanistan for Emerging Education Opportunities",

  // ✅ Single meaningful heading
  bannertitleone: "Study Abroad in Afghanistan with Affordable Education and",
  bannertitletwo: "Career Opportunities & Visa Guidance",

  bannerbgimg: "/images/Afghanistan-banner.png",

  img1: AfghanistanFirst,
  img2: AfghanistanSecond,

  heading1: "Study in Afghanistan for International Students",
  para1: <>Afghanistan is gradually emerging as a destination for students planning to <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad in Afghanistan</Link>, offering affordable education and developing academic opportunities. The country has growing universities in Afghanistan for international students providing programs in medicine, engineering, IT, and business.<br/><br/>
  At Nova EduBridge, we guide you through every step—from selecting universities in Afghanistan for international students to understanding Afghanistan student visa requirements and planning your academic journey effectively.</>,

  heading2: "Top Courses in Afghanistan Universities & Cost of Studying in Afghanistan",
  para2: <>Students who choose to study in Afghanistan can explore a range of top courses in Afghanistan universities including medicine, engineering, IT, agriculture, and business programs.<br/><br/>
  We also help you understand the cost of studying in Afghanistan, including tuition fees and living expenses, while providing complete guidance on Afghanistan student visa requirements.</>,

  carouseltitle: "Top Courses in Afghanistan Universities",
  carouselsubtitle: "Popular options for students planning to study abroad in Afghanistan include:",

  carousellist: [
    {
      img: AfghanistanCourse1,
      title: "Medicine & Healthcare",
      desc: "Top courses in Afghanistan universities with growing demand."
    },
    {
      img: AfghanistanCourse2,
      title: "Engineering & Construction",
      desc: "Programs aligned with infrastructure development needs."
    },
    {
      img: AfghanistanCourse3,
      title: "Information Technology",
      desc: "Emerging courses supporting digital growth."
    },
    {
      img: AfghanistanCourse4,
      title: "Agriculture & Business",
      desc: "Programs focused on economic and rural development."
    }
  ],

  milestones: [

    {
      title: "Universities in Afghanistan for International Students",
      content: {
        img: AfghanistanFaq1,
        heading: "Top Universities in Afghanistan for International Students",
        text: <>
        <b>Afghanistan offers universities in Afghanistan for international students that are evolving to meet global academic standards.</b><br/><br/>
        <ul>
          <li>Affordable education opportunities</li>
          <li>Developing academic infrastructure</li>
          <li>Practical learning approaches</li>
          <li>Supportive learning environment</li>
        </ul>
        <br/>
        <p>We help you choose suitable universities based on your academic and career goals.</p>
        </>
      }
    },

    {
      title: "Top Courses in Afghanistan Universities",
      content: {
        img: AfghanistanFaq2,
        heading: "Top Courses in Afghanistan Universities",
        text: <>
        Students can choose from a variety of top courses in Afghanistan universities such as:<br/><br/>
        <ul>
          <li>Medicine and Healthcare</li>
          <li>Engineering and Construction</li>
          <li>Information Technology</li>
          <li>Agriculture and Business</li>
        </ul>
        </>
      }
    },

    {
      title: "Cost of Studying in Afghanistan",
      content: {
        img: AfghanistanFaq3,
        heading: "Cost of Studying in Afghanistan",
        text: <>
        <b>The cost of studying in Afghanistan is relatively affordable compared to many other countries.</b><br/><br/>
        <ul>
          <li>Low tuition fees</li>
          <li>Affordable accommodation</li>
          <li>Low living expenses</li>
          <li>Value-for-money education</li>
        </ul>
        </>
      }
    },

    {
      title: "Career Opportunities in Afghanistan",
      content: {
        img: AfghanistanFaq4,
        heading: "Career Opportunities After Study in Afghanistan",
        text: <>
        Students graduating from universities in Afghanistan for international students can explore opportunities in healthcare, construction, IT, and agriculture sectors.<br/><br/>
        Afghanistan’s developing economy offers opportunities to contribute and grow professionally.
        </>
      }
    },

    {
      title: "Work While Studying in Afghanistan",
      content: {
        img: AfghanistanFaq1,
        heading: "Work While Studying in Afghanistan",
        text: <>
        Students who study in Afghanistan can explore limited work opportunities while studying, helping manage the cost of studying in Afghanistan and gain practical experience.<br/><br/>
        This enhances employability after graduation.
        </>
      }
    },

    {
      title: "Afghanistan Student Visa Requirements",
      content: {
        img: AfghanistanFaq2,
        heading: "Afghanistan Student Visa Requirements",
        text: <>
        <b>Understanding Afghanistan student visa requirements is essential to study abroad in Afghanistan.</b><br/><br/>
        <ul>
          <li>Admission letter from a recognized institution</li>
          <li>Valid passport and documents</li>
          <li>Proof of financial support</li>
          <li>Visa documentation and approvals</li>
        </ul>
        <br/>
        <p>We provide complete support to ensure a smooth visa application process.</p>
        </>
      }
    },

    {
      title: "Why Choose Nova EduBridge",
      content: {
        img: AfghanistanFaq3,
        heading: "Best Guidance to Study Abroad in Afghanistan",
        text: <>
        <ul>
          <li>Expert support for study abroad in Afghanistan</li>
          <li>Access to universities in Afghanistan for international students</li>
          <li>Guidance on top courses in Afghanistan universities</li>
          <li>Complete Afghanistan student visa requirements support</li>
          <li>Support in managing cost of studying in Afghanistan</li>
        </ul>
        <p>Whether you want to study in Afghanistan, explore universities in Afghanistan for international students, or understand the cost of studying in Afghanistan, Nova EduBridge provides complete support for your journey.</p>
        </>
      }
    }

  ]
},
  
  
{
  id: "Asia",
  bannersubtitle: "Study in Asia with Expert Visa Support",

  // ✅ Single meaningful heading
  bannertitleone: "Study and Work in Asia with Expert",
  bannertitletwo: "Student Visa Counselling & Visa Consultants",

  bannerbgimg: "/images/Asia-banner.png",

  img1: asiafirst,
  img2: asiasecond,

  heading1: "Study, Work, and Build Your Future in Asia with Expert Student Visa Counselling",
  para1: <>Asia is more than a continent — it’s a world of opportunity. From the technology-driven economies of Japan and South Korea to the thriving business hubs of Singapore, Dubai, and Hong Kong, to the cultural and academic richness of countries like India, Malaysia, and Thailand — Asia offers limitless possibilities.<br/><br/>
  At Nova EduBridge, we provide expert student visa counselling, visa counseling, and personalized guidance to help you <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study in Asia</Link>, explore jobs in Asia, and build long-term careers. As a trusted student visa consultant and visa expert, we ensure you receive complete support tailored to your goals.</>,

  heading2: "Why Choose Asia with a Trusted Student Visa Consultant?",
  para2: <>Asia is home to some of the fastest-growing economies in the world and attracts millions of students and professionals each year. Choosing to study in Asia becomes easier with the support of an experienced visa consultant and visa expert who understands the requirements and processes.<br/><br/>
  Our student visa counselling and visa counseling services ensure smooth admissions, proper documentation, and successful visa approvals, helping you focus on your academic and career growth.</>,

  carouseltitle: "How Nova EduBridge Supports Your Journey",
  carouselsubtitle: "Complete support from student visa counselling to career success",

  carousellist: [
    {
      img: asiacourse1,
      title: "Student Visa Counselling",
      desc: "Expert student visa counselling and visa counseling tailored to your study goals."
    },
    {
      img: asiacourse2,
      title: "University and Job Matching",
      desc: "Guidance from a trusted student visa consultant to match you with the right opportunities."
    },
    {
      img: asiacourse3,
      title: "Visa Consultant Support",
      desc: "Our visa consultant and visa expert team ensures accurate documentation and approvals."
    },
    {
      img: asiacourse4,
      title: "Pre-departure Training",
      desc: "Preparation and guidance for a smooth transition abroad."
    },
    {
      img: asiacourse5,
      title: "Ongoing Career Support",
      desc: "Continuous support from visa experts and career advisors."
    },
  ],

  milestones: [
    {
      title: 'Study in Asia with Student Visa Counselling',
      content: {
        img: asiafaq1,
        heading: 'Study in Asia with Expert Student Visa Counselling',
        text:  <><b>When you study in Asia, expert student visa counselling plays a crucial role in ensuring a smooth journey. Our visa consultants guide you through selecting the right universities and courses while handling documentation and visa processes.</b><br/><br/>
        <p>As experienced student visa consultants and visa experts, we assist with applications, visa approvals, accommodation, and pre-departure guidance.</p></>
      }
    },
    {
      title: 'Jobs in Asia with Visa Expert Guidance',
      content: {
        img: asiafaq2,
        heading: 'Jobs in Asia with Visa Consultant Support',
        text:  <><b>With the help of a visa consultant and visa expert, finding jobs in Asia becomes easier and more structured. We connect you with trusted recruiters and prepare you for interviews.</b><br/><br/>
        <p>Our visa counseling ensures you meet all work visa requirements and transition smoothly into your career.</p></>
      }
    },
    {
      title: 'Careers in Asia – Long-Term Growth',
      content: {
        img: asiafaq3,
        heading: 'Build Careers in Asia with Visa Experts',
        text:  <><b>Building careers in Asia becomes more achievable with expert visa counseling and professional guidance. Countries like Singapore, UAE, and Japan offer strong career growth and global exposure.</b><br/><br/>
        <p>Our student visa counselling and visa expert services help you plan long-term success.</p></>
      }
    },
    {
      title: 'Asia Visa Assistance',
      content: {
        img: asiafaq4,
        heading: 'Student Visa Counselling and Visa Consultant Support',
        text: <><b>Securing the correct visa requires proper guidance. Our student visa counselling and visa consultant services ensure accurate documentation and timely approvals.</b><br/><br/>
        <p>With our visa experts, your visa process becomes smooth and stress-free.</p></>
      }
    },
    {
      title: 'Jobs in Asia for Foreigners',
      content: {
        img: asiafaq5,
        heading: 'Global Careers with Visa Expert Support',
        text:  <><b>With the support of a visa expert and student visa consultant, you can explore jobs in Asia for foreigners across industries like IT, healthcare, finance, and hospitality.</b><br/><br/>
        <p>We ensure you find the right opportunities and transition smoothly into the workforce.</p></>
      }
    },
    {
      title: 'Start Your Journey with Nova EduBridge',
      content: {
        img: asiafaq6,
        heading: 'Start with Student Visa Counselling Today',
        text:  <>Whether your goal is to study in Asia, find a job, or build a long-term career, our student visa counselling, visa consultant services, and visa expert guidance ensure your success.<br/><br/>
        <p>Your journey begins with the right support — and Nova EduBridge is here to guide you every step of the way.</p>
        </>
      }
    }
  ]
},
{
  id: "Kazakhstan",
  bannersubtitle: "study in Kazakhstan",
  bannertitleone: "Study in Kazakhstan: Affordable Education, ",
  bannertitletwo: "Modern Infrastructure, and Global Opportunities",
  bannerbgimg: "/images/Kazakhstan-banner.png",

  img1: KazakhstanFirst,
  img2: KazakhstanSecond,

  heading1: "Study in Kazakhstan with Nova EduBridge – Build Your Global Career",

  para1: (
    <>
      Study in Kazakhstan is becoming a popular choice for international students looking for affordable and high-quality education. Study abroad in Kazakhstan offers access to Universities in Kazakhstan for international students that provide globally recognized degrees in medicine, engineering, business, and technology. Many institutions offer English-medium programs, making it easier for students worldwide. Along with understanding Kazakhstan student visa requirements, students can explore Top courses in Kazakhstan universities while benefiting from the Cost of studying in Kazakhstan, which is significantly lower compared to many countries. Nova EduBridge provides complete support to help you successfully study abroad in Kazakhstan.
    </>
  ),

  heading2: "Why Choose Kazakhstan?",

  para2: (
    <>
      Study in Kazakhstan offers a perfect combination of quality education and affordability. Universities in Kazakhstan for international students are recognized globally and provide strong academic programs. Study abroad in Kazakhstan also allows students to explore Top courses in Kazakhstan universities in fields like medicine, IT, and engineering. With simple Kazakhstan student visa requirements and low Cost of studying in Kazakhstan, students can achieve their academic goals without financial stress. The country’s growing economy and safe environment make study in Kazakhstan an excellent choice.
    </>
  ),

  carouseltitle: "Opportunities in Kazakhstan",
  carouselsubtitle: "Where education meets growth and innovation.",

  carousellist: [
    {
      img: KazakhstanCourse1,
      title: "Universities in Kazakhstan for International Students",
      desc: "Globally recognized institutions offering top programs for students choosing to study abroad in Kazakhstan."
    },
    {
      img: KazakhstanCourse2,
      title: "Cost of Studying in Kazakhstan",
      desc: "Affordable tuition fees and living expenses make study in Kazakhstan budget-friendly."
    },
    {
      img: KazakhstanCourse3,
      title: "Top Courses in Kazakhstan Universities",
      desc: "Choose from medicine, engineering, IT, and business programs while you study in Kazakhstan."
    },
    {
      img: KazakhstanCourse4,
      title: "Kazakhstan Student Visa Requirements",
      desc: "Simple and streamlined Kazakhstan student visa requirements for international students."
    }
  ],

  milestones: [
    {
      title: "Study in Kazakhstan",
      content: {
        img: KazakhstanFaq1,
        heading: "Affordable & Quality Education",
        text: (
          <>
            Study in Kazakhstan provides access to Universities in Kazakhstan for international students with high academic standards. Students can choose Top courses in Kazakhstan universities while benefiting from the low Cost of studying in Kazakhstan.<br /><br />
            Nova EduBridge helps you plan your study abroad in Kazakhstan journey smoothly.
          </>
        )
      }
    },
    {
      title: "Study Abroad in Kazakhstan",
      content: {
        img: KazakhstanFaq2,
        heading: "Career Opportunities",
        text: (
          <>
            Study abroad in Kazakhstan opens career opportunities in industries like IT, healthcare, and engineering. Graduates from Universities in Kazakhstan for international students are recognized globally.<br /><br />
            We guide you through Kazakhstan student visa requirements and career planning.
          </>
        )
      }
    },
    {
      title: "Top Courses in Kazakhstan Universities",
      content: {
        img: KazakhstanFaq3,
        heading: "Industry-Relevant Programs",
        text: (
          <>
            Students choosing to study in Kazakhstan can explore Top courses in Kazakhstan universities designed for global careers. Combined with affordable Cost of studying in Kazakhstan, this creates strong value.<br /><br />
            Nova EduBridge supports your academic journey from start to finish.
          </>
        )
      }
    },
    {
      title: "Kazakhstan Student Visa Requirements",
      content: {
        img: KazakhstanFaq4,
        heading: "Easy Visa Process",
        text: (
          <>
            Understanding Kazakhstan student visa requirements is essential for students planning to study abroad in Kazakhstan. Our team ensures smooth documentation and application support.<br /><br />
            With expert help, your transition to Universities in Kazakhstan for international students becomes seamless.
          </>
        )
      }
    }
  ]
},
{
  id: "China",
  bannersubtitle: "study in China",
  bannertitleone: "Study in China: World-Class Universities, ",
  bannertitletwo: "Innovation Hubs, and Rich Cultural Heritage",
  bannerbgimg: ChinaFirst,

  img1: ChinaFirst,
  img2: ChinaSecond,

  heading1: "Study in China with Nova EduBridge – Unlock Global Opportunities",

  para1: (
    <>
      Study in China has emerged as a top choice for international students seeking academic excellence and career growth. With over 1,000 Universities in China for international students, including many ranked in global top 100, China offers degrees in engineering, medicine, business, AI, and languages. Most top universities provide English-medium programs, and the Cost of studying in China is surprisingly affordable compared to Western countries. Understanding China student visa requirements is straightforward with proper guidance. Whether you explore Top courses in China universities or benefit from generous scholarships, study abroad in China through Nova EduBridge ensures a smooth and rewarding journey.
    </>
  ),

  heading2: "Why Choose China?",

  para2: (
    <>
      Study in China gives you access to rapidly growing economies, cutting-edge research, and globally respected degrees. Universities in China for international students are known for strong industry links and innovation. Study abroad in China also offers Top courses in China universities in fields like data science, renewable energy, traditional medicine, and finance. The China student visa requirements are well-structured, and the Cost of studying in China remains low with many scholarship options. Safe campuses, modern infrastructure, and rich cultural experiences make study in China a life-changing decision.
    </>
  ),

  carouseltitle: "Opportunities in China",
  carouselsubtitle: "Innovation, tradition, and global recognition — all in one place.",

  carousellist: [
    {
      img: ChinaCourse1,
      title: "Universities in China for International Students",
      desc: "Home to top-ranked universities like Tsinghua, Peking, and Fudan, offering world-class education."
    },
    {
      img: ChinaCourse2,
      title: "Cost of Studying in China",
      desc: "Low tuition fees and living costs, with scholarships covering up to 100% of expenses."
    },
    {
      img: ChinaCourse3,
      title: "Top Courses in China Universities",
      desc: "Popular programs include MBBS, Engineering, AI, Business, and Chinese Language & Culture."
    },
    {
      img: ChinaCourse4,
      title: "China Student Visa Requirements",
      desc: "Clear and simple visa process (X1/X2) with university admission and JW202 form."
    }
  ],

  milestones: [
    {
      title: "Study in China",
      content: {
        img: ChinaFaq1,
        heading: "Affordable Excellence",
        text: (
          <>
            Study in China combines high academic standards with low tuition fees. Universities in China for international students offer globally recognized degrees at a fraction of Western costs.<br /><br />
            Nova EduBridge helps you choose the right university and apply with confidence.
          </>
        )
      }
    },
    {
      title: "Study Abroad in China",
      content: {
        img: ChinaFaq2,
        heading: "Vast Career Networks",
        text: (
          <>
            Study abroad in China connects you to the world’s second-largest economy. Graduates from Top courses in China universities are highly sought after in tech, healthcare, and finance.<br /><br />
            We guide you through China student visa requirements and internship placements.
          </>
        )
      }
    },
    {
      title: "Top Courses in China Universities",
      content: {
        img: ChinaFaq3,
        heading: "Future-Ready Programs",
        text: (
          <>
            From Artificial Intelligence to Traditional Chinese Medicine, Top courses in China universities are designed for global relevance. The Cost of studying in China makes these programs highly accessible.<br /><br />
            Nova EduBridge ensures you pick the right course for your career.
          </>
        )
      }
    },
    {
      title: "China Student Visa Requirements",
      content: {
        img: ChinaFaq4,
        heading: "Hassle-Free Visa Support",
        text: (
          <>
            Understanding China student visa requirements (X1 for long-term, X2 for short-term) is easy with our step-by-step assistance. We help with admission letters, JW202 forms, and medical checks.<br /><br />
            Your journey to study in China starts with stress-free documentation.
          </>
        )
      }
    }
  ]
},
{
  id: "South Korea",
  bannersubtitle: "study in South Korea",
  bannertitleone: "Study in South Korea: Top-Tier Technology, ",
  bannertitletwo: "Scholarships, and Global Career Pathways",
  bannerbgimg: SouthKoreaFirst,

  img1: SouthKoreaFirst,
  img2: SouthKoreaSecond,

  heading1: "Study in South Korea with Nova EduBridge – Your Gateway to Asia’s Innovation Hub",

  para1: (
    <>
      Study in South Korea is ideal for students who want cutting-edge education combined with rich culture and global career prospects. Universities in South Korea for international students, such as Seoul National University, KAIST, and Korea University, are ranked among the best in Asia. Many programs are taught in English, especially at the graduate level. The Cost of studying in South Korea is moderate, but generous scholarships and part-time work opportunities make it affordable. Understanding South Korea student visa requirements (D-2) is simple with expert help. Explore Top courses in South Korea universities in AI, semiconductors, K-pop production, business, and engineering. Study abroad in South Korea with Nova EduBridge for a truly transformative experience.
    </>
  ),

  heading2: "Why Choose South Korea?",

  para2: (
    <>
      Study in South Korea places you at the heart of global innovation, from Samsung and LG to K-culture and smart cities. Universities in South Korea for international students offer world-class research facilities and strong industry partnerships. Study abroad in South Korea also provides access to Top courses in South Korea universities in robotics, game design, Korean language, and global business. The South Korea student visa requirements are clear and student-friendly. With reasonable Cost of studying in South Korea and high ROI, study in South Korea is a smart investment in your future.
    </>
  ),

  carouseltitle: "Opportunities in South Korea",
  carouselsubtitle: "Where tradition meets technology and dreams take flight.",

  carousellist: [
    {
      img: KoreaCourse1,
      title: "Universities in South Korea for International Students",
      desc: "Globally ranked universities known for research, innovation, and English-taught programs."
    },
    {
      img: KoreaCourse2,
      title: "Cost of Studying in South Korea",
      desc: "Affordable tuition from $3,000–$8,000/year with generous scholarships and part-time jobs."
    },
    {
      img: KoreaCourse3,
      title: "Top Courses in South Korea Universities",
      desc: "Popular choices include AI, Semiconductor Engineering, K-Beauty Science, Business, and Korean Studies."
    },
    {
      img: KoreaCourse4,
      title: "South Korea Student Visa Requirements",
      desc: "D-2 visa process with admission letter, financial proof, and simple documentation."
    }
  ],

  milestones: [
    {
      title: "Study in South Korea",
      content: {
        img: KoreaFaq1,
        heading: "Innovation Meets Affordability",
        text: (
          <>
            Study in South Korea gives you access to top tech and business education at reasonable costs. Universities in South Korea for international students offer high ROI through internships at global giants.<br /><br />
            Nova EduBridge helps you secure admissions and scholarships.
          </>
        )
      }
    },
    {
      title: "Study Abroad in South Korea",
      content: {
        img: KoreaFaq2,
        heading: "Global Career Launchpad",
        text: (
          <>
            Study abroad in South Korea opens doors to careers at Samsung, Hyundai, LG, and global K-content firms. Top courses in South Korea universities are designed with direct industry input.<br /><br />
            We support you from South Korea student visa requirements to job search strategies.
          </>
        )
      }
    },
    {
      title: "Top Courses in South Korea Universities",
      content: {
        img: KoreaFaq3,
        heading: "Future-Focused Curriculum",
        text: (
          <>
            Whether it’s AI, K-pop production, or global business, Top courses in South Korea universities are ahead of global trends. The Cost of studying in South Korea is balanced by excellent career outcomes.<br /><br />
            Nova EduBridge matches you with the best programs for your goals.
          </>
        )
      }
    },
    {
      title: "South Korea Student Visa Requirements",
      content: {
        img: KoreaFaq4,
        heading: "Simple & Fast Visa Process",
        text: (
          <>
            Navigating South Korea student visa requirements (D-2) is easy with our checklist — admission letter, financial proof, and health insurance. We ensure no delays.<br /><br />
            Your dream to study in South Korea begins with a stress-free visa approval.
          </>
        )
      }
    }
  ]
},
{
  id: "Japan",
  bannersubtitle: "study in Japan",
  bannertitleone: "Study in Japan: World-Class Education, ",
  bannertitletwo: "Innovation, and Global Career Opportunities",
  bannerbgimg: JapanFirst,

  img1: JapanFirst,
  img2: JapanSecond,

  heading1: "Study in Japan with Nova EduBridge – Your Gateway to Academic Excellence and Innovation",

  para1: (
    <>
      Study in Japan is an excellent choice for students seeking high-quality education, advanced technology, and a unique cultural experience. Universities in Japan for international students, such as the University of Tokyo, Kyoto University, and Osaka University, are globally recognized for academic excellence and research. Many universities offer English-taught programs, making it easier for international students to pursue their goals. The Cost of studying in Japan is competitive, with numerous scholarships available through government and university programs. Understanding Japan student visa requirements is straightforward with expert guidance. Explore Top courses in Japan universities in robotics, engineering, business, artificial intelligence, healthcare, and animation. Study abroad in Japan with Nova EduBridge and unlock a future filled with innovation and global opportunities.
    </>
  ),

  heading2: "Why Choose Japan?",

  para2: (
    <>
      Study in Japan allows you to learn in one of the world's most technologically advanced and culturally rich nations. Universities in Japan for international students offer cutting-edge facilities, industry collaborations, and internationally recognized degrees. Study abroad in Japan provides access to Top courses in Japan universities across fields such as robotics, automotive engineering, gaming technology, international business, and data science. The Japan student visa requirements are student-friendly and well-structured. With a reasonable Cost of studying in Japan and excellent employment prospects, study in Japan offers outstanding value for ambitious students.
    </>
  ),

  carouseltitle: "Opportunities in Japan",
  carouselsubtitle: "Experience innovation, tradition, and limitless possibilities.",

  carousellist: [
    {
      img: JapanCourse1,
      title: "Universities in Japan for International Students",
      desc: "Globally respected institutions offering advanced research facilities and English-taught programs."
    },
    {
      img: JapanCourse2,
      title: "Cost of Studying in Japan",
      desc: "Affordable tuition with numerous scholarships, grants, and part-time work opportunities."
    },
    {
      img: JapanCourse3,
      title: "Top Courses in Japan Universities",
      desc: "Popular programs include Robotics, Artificial Intelligence, Business, Animation, Engineering, and Healthcare."
    },
    {
      img: JapanCourse4,
      title: "Japan Student Visa Requirements",
      desc: "Simple visa process with admission confirmation, financial proof, and required documentation."
    }
  ],

  milestones: [
    {
      title: "Study in Japan",
      content: {
        img: JapanFaq1,
        heading: "Global Education Excellence",
        text: (
          <>
            Study in Japan offers internationally recognized degrees, world-class faculty, and hands-on learning opportunities. Universities in Japan for international students are known for innovation and academic rigor.<br /><br />
            Nova EduBridge helps you find the right university and scholarship opportunities.
          </>
        )
      }
    },
    {
      title: "Study Abroad in Japan",
      content: {
        img: JapanFaq2,
        heading: "Career Opportunities Worldwide",
        text: (
          <>
            Study abroad in Japan opens doors to careers with leading multinational companies and innovative startups. Top courses in Japan universities are designed to meet global industry demands.<br /><br />
            We guide you through admissions, accommodation, and career planning.
          </>
        )
      }
    },
    {
      title: "Top Courses in Japan Universities",
      content: {
        img: JapanFaq3,
        heading: "Future-Ready Learning",
        text: (
          <>
            From Robotics and Artificial Intelligence to Animation and International Business, Top courses in Japan universities equip students with practical skills and global perspectives. The Cost of studying in Japan is balanced by strong career outcomes.<br /><br />
            Nova EduBridge helps match your interests with the best academic programs.
          </>
        )
      }
    },
    {
      title: "Japan Student Visa Requirements",
      content: {
        img: JapanFaq4,
        heading: "Smooth Visa Application Support",
        text: (
          <>
            Understanding Japan student visa requirements is easy with professional guidance. Required documents typically include a Certificate of Eligibility, admission letter, passport, and proof of funds.<br /><br />
            Nova EduBridge ensures a hassle-free visa process so you can focus on your studies.
          </>
        )
      }
    }
  ]
}
];
